/**
 * Generated by orval v6.23.0 🍺
 * Do not edit manually.
 * APIs for RCI FE
 * This document describes the APIs provided by NeoAP BE for RCI FE, designed to be integrated into NeoAP FE using `iframe`.\
These APIs utilize cookie-based authentication. All API requests must include the cookie `_ap_session`.

 * OpenAPI spec version: 1
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useSuspenseInfiniteQuery,
  useSuspenseQuery,
} from '@tanstack/react-query';
import type {
  InfiniteData,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import type { ApprovingInvoiceReportApprovalResponse } from '../model/approvingInvoiceReportApprovalResponse';
import type { ApprovingInvoiceReportApprovalRouteResponse } from '../model/approvingInvoiceReportApprovalRouteResponse';
import type { ApprovingInvoiceReportBusinessDocumentResponse } from '../model/approvingInvoiceReportBusinessDocumentResponse';
import type { ApprovingInvoiceReportDisapprovalRequest } from '../model/approvingInvoiceReportDisapprovalRequest';
import type { ApprovingInvoiceReportDisapprovalResponse } from '../model/approvingInvoiceReportDisapprovalResponse';
import type { ApprovingInvoiceReportDisapprovalRouteResponse } from '../model/approvingInvoiceReportDisapprovalRouteResponse';
import type { ApprovingInvoiceReportPaymentInfoResponse } from '../model/approvingInvoiceReportPaymentInfoResponse';
import type { BadRequestResponse } from '../model/badRequestResponse';
import type { BulkApprovalInvoiceReportsRequest } from '../model/bulkApprovalInvoiceReportsRequest';
import type { BulkApprovalInvoiceReportsResponse } from '../model/bulkApprovalInvoiceReportsResponse';
import type { BulkDestroyInvoiceReports200 } from '../model/bulkDestroyInvoiceReports200';
import type { BulkDestroyInvoiceReportsRequest } from '../model/bulkDestroyInvoiceReportsRequest';
import type { CancelInvoiceReportResponse } from '../model/cancelInvoiceReportResponse';
import type { CommonError } from '../model/commonError';
import type { CopyInvoiceReportResponse } from '../model/copyInvoiceReportResponse';
import type { CreateApprovingInvoiceReportApprovalRequest } from '../model/createApprovingInvoiceReportApprovalRequest';
import type { CreateInvoiceReportResponse } from '../model/createInvoiceReportResponse';
import type { DeleteInvoiceReportViewersRequest } from '../model/deleteInvoiceReportViewersRequest';
import type { ForbiddenResponse } from '../model/forbiddenResponse';
import type { GetApprovingInvoiceReportInvoiceTransactions200 } from '../model/getApprovingInvoiceReportInvoiceTransactions200';
import type { GetApprovingInvoiceReportInvoiceTransactionsParams } from '../model/getApprovingInvoiceReportInvoiceTransactionsParams';
import type { GetApprovingInvoiceReportJournal200 } from '../model/getApprovingInvoiceReportJournal200';
import type { GetInvoiceReportSampleImportCsvParams } from '../model/getInvoiceReportSampleImportCsvParams';
import type { GetInvoiceReportStatusesParams } from '../model/getInvoiceReportStatusesParams';
import type { GetInvoiceReportSummaryResponse } from '../model/getInvoiceReportSummaryResponse';
import type { GetInvoiceReportViewersResponse } from '../model/getInvoiceReportViewersResponse';
import type { GetOfficeMembersResponse } from '../model/getOfficeMembersResponse';
import type { GetReferenceRecentApprovedInvoiceReportsParams } from '../model/getReferenceRecentApprovedInvoiceReportsParams';
import type { GetTargetApplicantsForInvoiceReportsParams } from '../model/getTargetApplicantsForInvoiceReportsParams';
import type { ImportInvoiceReportsRequest } from '../model/importInvoiceReportsRequest';
import type { ImportInvoiceReportsResponse } from '../model/importInvoiceReportsResponse';
import type { InvoiceFilesStatusesResponse } from '../model/invoiceFilesStatusesResponse';
import type { InvoiceReportApprovalRouteResponse } from '../model/invoiceReportApprovalRouteResponse';
import type { InvoiceReportBusinessDocumentResponse } from '../model/invoiceReportBusinessDocumentResponse';
import type { InvoiceReportDetailReportSummaryResponse } from '../model/invoiceReportDetailReportSummaryResponse';
import type { InvoiceReportDetailResponse } from '../model/invoiceReportDetailResponse';
import type { InvoiceReportJournalResponse } from '../model/invoiceReportJournalResponse';
import type { InvoiceReportPaymentInfoResponse } from '../model/invoiceReportPaymentInfoResponse';
import type { InvoiceReportPaymentStatusesResponse } from '../model/invoiceReportPaymentStatusesResponse';
import type { InvoiceReportStatusesResponse } from '../model/invoiceReportStatusesResponse';
import type { InvoiceTransactionsResponse } from '../model/invoiceTransactionsResponse';
import type { NotFoundResponse } from '../model/notFoundResponse';
import type { OfficeInvoiceReportSettings } from '../model/officeInvoiceReportSettings';
import type { PutInvoiceReportViewersRequest } from '../model/putInvoiceReportViewersRequest';
import type { ReferenceInvoiceTransactionsResponse } from '../model/referenceInvoiceTransactionsResponse';
import type { ReferenceRecentApprovedInvoiceReportsResponse } from '../model/referenceRecentApprovedInvoiceReportsResponse';
import type { SearchApprovingInvoiceReportsParams } from '../model/searchApprovingInvoiceReportsParams';
import type { SearchApprovingInvoiceReportsRequest } from '../model/searchApprovingInvoiceReportsRequest';
import type { SearchApprovingInvoiceReportsResponse } from '../model/searchApprovingInvoiceReportsResponse';
import type { SearchInvoiceReportsParams } from '../model/searchInvoiceReportsParams';
import type { SearchInvoiceReportsRequest } from '../model/searchInvoiceReportsRequest';
import type { SearchInvoiceReportsResponse } from '../model/searchInvoiceReportsResponse';
import type { UnauthorizedResponse } from '../model/unauthorizedResponse';
import type { UnprocessableEntityResponse } from '../model/unprocessableEntityResponse';
import { useCustomClient } from '../../mutator/custom-instance';
import type { ErrorType, BodyType } from '../../mutator/custom-instance';
import { customFomDataFn } from '../../api/formData/custom-function';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P
) => any
  ? P
  : never;

/**
 * Returns office members that can be selected as applicants (申請者) when creating or searching invoice reports. <br/>
When the current user is an agent applicant (代理申請者), the list is limited to their designated target office members.

 * @summary Get target applicants for invoice reports
 */
export const useGetTargetApplicantsForInvoiceReportsHook = () => {
  const getTargetApplicantsForInvoiceReports =
    useCustomClient<GetOfficeMembersResponse>();

  return (
    params?: GetTargetApplicantsForInvoiceReportsParams,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>
  ) => {
    return getTargetApplicantsForInvoiceReports(
      {
        url: `/api/js/agent_applicant_target_office_members`,
        method: 'GET',
        params,
      },
      options
    );
  };
};

export const getGetTargetApplicantsForInvoiceReportsQueryKey = (
  params?: GetTargetApplicantsForInvoiceReportsParams
) => {
  return [
    `/api/js/agent_applicant_target_office_members`,
    ...(params ? [params] : []),
  ] as const;
};

export const useGetTargetApplicantsForInvoiceReportsInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<
      ReturnType<ReturnType<typeof useGetTargetApplicantsForInvoiceReportsHook>>
    >,
    GetTargetApplicantsForInvoiceReportsParams['page']
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  params?: GetTargetApplicantsForInvoiceReportsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useGetTargetApplicantsForInvoiceReportsHook>
          >
        >,
        TError,
        TData,
        Awaited<
          ReturnType<
            ReturnType<typeof useGetTargetApplicantsForInvoiceReportsHook>
          >
        >,
        QueryKey,
        GetTargetApplicantsForInvoiceReportsParams['page']
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetTargetApplicantsForInvoiceReportsQueryKey(params);

  const getTargetApplicantsForInvoiceReports =
    useGetTargetApplicantsForInvoiceReportsHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<ReturnType<typeof useGetTargetApplicantsForInvoiceReportsHook>>
    >,
    QueryKey,
    GetTargetApplicantsForInvoiceReportsParams['page']
  > = ({ pageParam }) =>
    getTargetApplicantsForInvoiceReports(
      { ...params, page: pageParam || params?.['page'] },
      requestOptions
    );

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useGetTargetApplicantsForInvoiceReportsHook>>
    >,
    TError,
    TData,
    Awaited<
      ReturnType<ReturnType<typeof useGetTargetApplicantsForInvoiceReportsHook>>
    >,
    QueryKey,
    GetTargetApplicantsForInvoiceReportsParams['page']
  > & { queryKey: QueryKey };
};

export type GetTargetApplicantsForInvoiceReportsInfiniteQueryResult =
  NonNullable<
    Awaited<
      ReturnType<ReturnType<typeof useGetTargetApplicantsForInvoiceReportsHook>>
    >
  >;
export type GetTargetApplicantsForInvoiceReportsInfiniteQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Get target applicants for invoice reports
 */
export const useGetTargetApplicantsForInvoiceReportsInfinite = <
  TData = InfiniteData<
    Awaited<
      ReturnType<ReturnType<typeof useGetTargetApplicantsForInvoiceReportsHook>>
    >,
    GetTargetApplicantsForInvoiceReportsParams['page']
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  params?: GetTargetApplicantsForInvoiceReportsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useGetTargetApplicantsForInvoiceReportsHook>
          >
        >,
        TError,
        TData,
        Awaited<
          ReturnType<
            ReturnType<typeof useGetTargetApplicantsForInvoiceReportsHook>
          >
        >,
        QueryKey,
        GetTargetApplicantsForInvoiceReportsParams['page']
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useGetTargetApplicantsForInvoiceReportsInfiniteQueryOptions(
      params,
      options
    );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetTargetApplicantsForInvoiceReportsSuspenseQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetTargetApplicantsForInvoiceReportsHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  params?: GetTargetApplicantsForInvoiceReportsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useGetTargetApplicantsForInvoiceReportsHook>
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetTargetApplicantsForInvoiceReportsQueryKey(params);

  const getTargetApplicantsForInvoiceReports =
    useGetTargetApplicantsForInvoiceReportsHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<ReturnType<typeof useGetTargetApplicantsForInvoiceReportsHook>>
    >
  > = () => getTargetApplicantsForInvoiceReports(params, requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useGetTargetApplicantsForInvoiceReportsHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTargetApplicantsForInvoiceReportsSuspenseQueryResult =
  NonNullable<
    Awaited<
      ReturnType<ReturnType<typeof useGetTargetApplicantsForInvoiceReportsHook>>
    >
  >;
export type GetTargetApplicantsForInvoiceReportsSuspenseQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Get target applicants for invoice reports
 */
export const useGetTargetApplicantsForInvoiceReportsSuspense = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetTargetApplicantsForInvoiceReportsHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  params?: GetTargetApplicantsForInvoiceReportsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useGetTargetApplicantsForInvoiceReportsHook>
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useGetTargetApplicantsForInvoiceReportsSuspenseQueryOptions(
      params,
      options
    );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetTargetApplicantsForInvoiceReportsSuspenseInfiniteQueryOptions =
  <
    TData = InfiniteData<
      Awaited<
        ReturnType<
          ReturnType<typeof useGetTargetApplicantsForInvoiceReportsHook>
        >
      >,
      GetTargetApplicantsForInvoiceReportsParams['page']
    >,
    TError = ErrorType<
      | BadRequestResponse
      | UnauthorizedResponse
      | ForbiddenResponse
      | NotFoundResponse
      | UnprocessableEntityResponse
    >
  >(
    params?: GetTargetApplicantsForInvoiceReportsParams,
    options?: {
      query?: Partial<
        UseSuspenseInfiniteQueryOptions<
          Awaited<
            ReturnType<
              ReturnType<typeof useGetTargetApplicantsForInvoiceReportsHook>
            >
          >,
          TError,
          TData,
          Awaited<
            ReturnType<
              ReturnType<typeof useGetTargetApplicantsForInvoiceReportsHook>
            >
          >,
          QueryKey,
          GetTargetApplicantsForInvoiceReportsParams['page']
        >
      >;
      request?: SecondParameter<ReturnType<typeof useCustomClient>>;
    }
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetTargetApplicantsForInvoiceReportsQueryKey(params);

    const getTargetApplicantsForInvoiceReports =
      useGetTargetApplicantsForInvoiceReportsHook();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          ReturnType<typeof useGetTargetApplicantsForInvoiceReportsHook>
        >
      >,
      QueryKey,
      GetTargetApplicantsForInvoiceReportsParams['page']
    > = ({ pageParam }) =>
      getTargetApplicantsForInvoiceReports(
        { ...params, page: pageParam || params?.['page'] },
        requestOptions
      );

    return {
      queryKey,
      queryFn,
      ...queryOptions,
    } as UseSuspenseInfiniteQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useGetTargetApplicantsForInvoiceReportsHook>
        >
      >,
      TError,
      TData,
      Awaited<
        ReturnType<
          ReturnType<typeof useGetTargetApplicantsForInvoiceReportsHook>
        >
      >,
      QueryKey,
      GetTargetApplicantsForInvoiceReportsParams['page']
    > & { queryKey: QueryKey };
  };

export type GetTargetApplicantsForInvoiceReportsSuspenseInfiniteQueryResult =
  NonNullable<
    Awaited<
      ReturnType<ReturnType<typeof useGetTargetApplicantsForInvoiceReportsHook>>
    >
  >;
export type GetTargetApplicantsForInvoiceReportsSuspenseInfiniteQueryError =
  ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >;

/**
 * @summary Get target applicants for invoice reports
 */
export const useGetTargetApplicantsForInvoiceReportsSuspenseInfinite = <
  TData = InfiniteData<
    Awaited<
      ReturnType<ReturnType<typeof useGetTargetApplicantsForInvoiceReportsHook>>
    >,
    GetTargetApplicantsForInvoiceReportsParams['page']
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  params?: GetTargetApplicantsForInvoiceReportsParams,
  options?: {
    query?: Partial<
      UseSuspenseInfiniteQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useGetTargetApplicantsForInvoiceReportsHook>
          >
        >,
        TError,
        TData,
        Awaited<
          ReturnType<
            ReturnType<typeof useGetTargetApplicantsForInvoiceReportsHook>
          >
        >,
        QueryKey,
        GetTargetApplicantsForInvoiceReportsParams['page']
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useGetTargetApplicantsForInvoiceReportsSuspenseInfiniteQueryOptions(
      params,
      options
    );

  const query = useSuspenseInfiniteQuery(
    queryOptions
  ) as UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Create an invoice report from a received invoice
 */
export const useCreateInvoiceReportHook = () => {
  const createInvoiceReport = useCustomClient<CreateInvoiceReportResponse>();

  return (
    id: string,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>
  ) => {
    return createInvoiceReport(
      {
        url: `/api/js/received_invoice/v1/received_invoices/${id}/invoice_report`,
        method: 'POST',
      },
      options
    );
  };
};

export const useCreateInvoiceReportMutationOptions = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | CommonError
    | NotFoundResponse
    | UnprocessableEntityResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateInvoiceReportHook>>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCreateInvoiceReportHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const createInvoiceReport = useCreateInvoiceReportHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCreateInvoiceReportHook>>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return createInvoiceReport(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateInvoiceReportMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCreateInvoiceReportHook>>>
>;

export type CreateInvoiceReportMutationError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | CommonError
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Create an invoice report from a received invoice
 */
export const useCreateInvoiceReport = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | CommonError
    | NotFoundResponse
    | UnprocessableEntityResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateInvoiceReportHook>>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const mutationOptions = useCreateInvoiceReportMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Provides a sample CSV file for importing invoice reports.
Returns 403 if the office does not have accounting service linkage configured.

 * @summary Get a sample CSV for importing invoice reports
 */
export const useGetInvoiceReportSampleImportCsvHook = () => {
  const getInvoiceReportSampleImportCsv = useCustomClient<Blob>();

  return (
    params: GetInvoiceReportSampleImportCsvParams,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>,
    signal?: AbortSignal
  ) => {
    return getInvoiceReportSampleImportCsv(
      {
        url: `/api/js/invoice_reports/sample_import_csv`,
        method: 'GET',
        params,
        responseType: 'blob',
        signal,
      },
      options
    );
  };
};

export const getGetInvoiceReportSampleImportCsvQueryKey = (
  params: GetInvoiceReportSampleImportCsvParams
) => {
  return [
    `/api/js/invoice_reports/sample_import_csv`,
    ...(params ? [params] : []),
  ] as const;
};

export const useGetInvoiceReportSampleImportCsvQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetInvoiceReportSampleImportCsvHook>>
  >,
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
  >
>(
  params: GetInvoiceReportSampleImportCsvParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetInvoiceReportSampleImportCsvHook>>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetInvoiceReportSampleImportCsvQueryKey(params);

  const getInvoiceReportSampleImportCsv =
    useGetInvoiceReportSampleImportCsvHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<ReturnType<typeof useGetInvoiceReportSampleImportCsvHook>>
    >
  > = ({ signal }) =>
    getInvoiceReportSampleImportCsv(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useGetInvoiceReportSampleImportCsvHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInvoiceReportSampleImportCsvQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportSampleImportCsvHook>>>
>;
export type GetInvoiceReportSampleImportCsvQueryError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
>;

/**
 * @summary Get a sample CSV for importing invoice reports
 */
export const useGetInvoiceReportSampleImportCsv = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetInvoiceReportSampleImportCsvHook>>
  >,
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
  >
>(
  params: GetInvoiceReportSampleImportCsvParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetInvoiceReportSampleImportCsvHook>>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetInvoiceReportSampleImportCsvQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetInvoiceReportSampleImportCsvSuspenseQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetInvoiceReportSampleImportCsvHook>>
  >,
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
  >
>(
  params: GetInvoiceReportSampleImportCsvParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetInvoiceReportSampleImportCsvHook>>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetInvoiceReportSampleImportCsvQueryKey(params);

  const getInvoiceReportSampleImportCsv =
    useGetInvoiceReportSampleImportCsvHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<ReturnType<typeof useGetInvoiceReportSampleImportCsvHook>>
    >
  > = ({ signal }) =>
    getInvoiceReportSampleImportCsv(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useGetInvoiceReportSampleImportCsvHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInvoiceReportSampleImportCsvSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportSampleImportCsvHook>>>
>;
export type GetInvoiceReportSampleImportCsvSuspenseQueryError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
>;

/**
 * @summary Get a sample CSV for importing invoice reports
 */
export const useGetInvoiceReportSampleImportCsvSuspense = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetInvoiceReportSampleImportCsvHook>>
  >,
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
  >
>(
  params: GetInvoiceReportSampleImportCsvParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetInvoiceReportSampleImportCsvHook>>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetInvoiceReportSampleImportCsvSuspenseQueryOptions(
    params,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Import invoice reports from a CSV file
 */
export const useImportInvoiceReportsHook = () => {
  const importInvoiceReports = useCustomClient<ImportInvoiceReportsResponse>();

  return (
    importInvoiceReportsRequest: BodyType<ImportInvoiceReportsRequest>,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>
  ) => {
    const formData = customFomDataFn(importInvoiceReportsRequest);
    return importInvoiceReports(
      {
        url: `/api/js/invoice_reports/import`,
        method: 'POST',
        headers: { 'Content-Type': 'multipart/form-data' },
        data: formData,
      },
      options
    );
  };
};

export const useImportInvoiceReportsMutationOptions = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useImportInvoiceReportsHook>>>,
    TError,
    { data: BodyType<ImportInvoiceReportsRequest> },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useImportInvoiceReportsHook>>>,
  TError,
  { data: BodyType<ImportInvoiceReportsRequest> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const importInvoiceReports = useImportInvoiceReportsHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useImportInvoiceReportsHook>>>,
    { data: BodyType<ImportInvoiceReportsRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return importInvoiceReports(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ImportInvoiceReportsMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useImportInvoiceReportsHook>>>
>;
export type ImportInvoiceReportsMutationBody =
  BodyType<ImportInvoiceReportsRequest>;
export type ImportInvoiceReportsMutationError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Import invoice reports from a CSV file
 */
export const useImportInvoiceReports = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useImportInvoiceReportsHook>>>,
    TError,
    { data: BodyType<ImportInvoiceReportsRequest> },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const mutationOptions = useImportInvoiceReportsMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Get details of an invoice report
 */
export const useGetInvoiceReportHook = () => {
  const getInvoiceReport = useCustomClient<InvoiceReportDetailResponse>();

  return (
    id: string,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>,
    signal?: AbortSignal
  ) => {
    return getInvoiceReport(
      { url: `/api/js/invoice_reports/${id}`, method: 'GET', signal },
      options
    );
  };
};

export const getGetInvoiceReportQueryKey = (id: string) => {
  return [`/api/js/invoice_reports/${id}`] as const;
};

export const useGetInvoiceReportQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportHook>>>,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetInvoiceReportQueryKey(id);

  const getInvoiceReport = useGetInvoiceReportHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportHook>>>
  > = ({ signal }) => getInvoiceReport(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInvoiceReportQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportHook>>>
>;
export type GetInvoiceReportQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Get details of an invoice report
 */
export const useGetInvoiceReport = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportHook>>>,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetInvoiceReportQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetInvoiceReportSuspenseQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportHook>>>,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetInvoiceReportQueryKey(id);

  const getInvoiceReport = useGetInvoiceReportHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportHook>>>
  > = ({ signal }) => getInvoiceReport(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseSuspenseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInvoiceReportSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportHook>>>
>;
export type GetInvoiceReportSuspenseQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Get details of an invoice report
 */
export const useGetInvoiceReportSuspense = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportHook>>>,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetInvoiceReportSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Destroys multiple invoice reports (payment requests) in a single request.

**Restrictions**:
- Maximum 50 reports per request
- Only destroyable reports can be destroyed (unsubmitted, canceled, or rejected status)
- Reports with status "waiting for approval" or "approved" cannot be destroyed

**Behavior**:
- If all reports are destroyed successfully, returns 200 OK with a success message
- If report_ids is missing, empty, or not an array, returns 400 Bad Request
- If any report cannot be destroyed (e.g. waiting/approved), returns 422 Unprocessable Entity
- If more than 50 reports are requested, returns 400 Bad Request

 * @summary Bulk destroy multiple invoice reports
 */
export const useBulkDestroyInvoiceReportsHook = () => {
  const bulkDestroyInvoiceReports =
    useCustomClient<BulkDestroyInvoiceReports200>();

  return (
    bulkDestroyInvoiceReportsRequest: BodyType<BulkDestroyInvoiceReportsRequest>,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>
  ) => {
    return bulkDestroyInvoiceReports(
      {
        url: `/api/js/invoice_reports/bulk_destroy`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: bulkDestroyInvoiceReportsRequest,
      },
      options
    );
  };
};

export const useBulkDestroyInvoiceReportsMutationOptions = <
  TError = ErrorType<
    CommonError | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useBulkDestroyInvoiceReportsHook>>>,
    TError,
    { data: BodyType<BulkDestroyInvoiceReportsRequest> },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useBulkDestroyInvoiceReportsHook>>>,
  TError,
  { data: BodyType<BulkDestroyInvoiceReportsRequest> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const bulkDestroyInvoiceReports = useBulkDestroyInvoiceReportsHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useBulkDestroyInvoiceReportsHook>>>,
    { data: BodyType<BulkDestroyInvoiceReportsRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return bulkDestroyInvoiceReports(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkDestroyInvoiceReportsMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useBulkDestroyInvoiceReportsHook>>>
>;
export type BulkDestroyInvoiceReportsMutationBody =
  BodyType<BulkDestroyInvoiceReportsRequest>;
export type BulkDestroyInvoiceReportsMutationError = ErrorType<
  CommonError | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
>;

/**
 * @summary Bulk destroy multiple invoice reports
 */
export const useBulkDestroyInvoiceReports = <
  TError = ErrorType<
    CommonError | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useBulkDestroyInvoiceReportsHook>>>,
    TError,
    { data: BodyType<BulkDestroyInvoiceReportsRequest> },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const mutationOptions = useBulkDestroyInvoiceReportsMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Get a list of invoice reports
 */
export const useSearchInvoiceReportsHook = () => {
  const searchInvoiceReports = useCustomClient<
    SearchInvoiceReportsResponse | Blob
  >();

  return (
    searchInvoiceReportsRequest: BodyType<SearchInvoiceReportsRequest>,
    params?: SearchInvoiceReportsParams,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>
  ) => {
    return searchInvoiceReports(
      {
        url: `/api/js/invoice_reports/search`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: searchInvoiceReportsRequest,
        params,
      },
      options
    );
  };
};

export const getSearchInvoiceReportsQueryKey = (
  searchInvoiceReportsRequest: SearchInvoiceReportsRequest,
  params?: SearchInvoiceReportsParams
) => {
  return [
    `/api/js/invoice_reports/search`,
    ...(params ? [params] : []),
    searchInvoiceReportsRequest,
  ] as const;
};

export const useSearchInvoiceReportsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useSearchInvoiceReportsHook>>>,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  searchInvoiceReportsRequest: SearchInvoiceReportsRequest,
  params?: SearchInvoiceReportsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useSearchInvoiceReportsHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSearchInvoiceReportsQueryKey(searchInvoiceReportsRequest, params);

  const searchInvoiceReports = useSearchInvoiceReportsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useSearchInvoiceReportsHook>>>
  > = () =>
    searchInvoiceReports(searchInvoiceReportsRequest, params, requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useSearchInvoiceReportsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SearchInvoiceReportsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useSearchInvoiceReportsHook>>>
>;
export type SearchInvoiceReportsQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Get a list of invoice reports
 */
export const useSearchInvoiceReports = <
  TData = Awaited<ReturnType<ReturnType<typeof useSearchInvoiceReportsHook>>>,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  searchInvoiceReportsRequest: SearchInvoiceReportsRequest,
  params?: SearchInvoiceReportsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useSearchInvoiceReportsHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useSearchInvoiceReportsQueryOptions(
    searchInvoiceReportsRequest,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useSearchInvoiceReportsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useSearchInvoiceReportsHook>>>,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  searchInvoiceReportsRequest: SearchInvoiceReportsRequest,
  params?: SearchInvoiceReportsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useSearchInvoiceReportsHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSearchInvoiceReportsQueryKey(searchInvoiceReportsRequest, params);

  const searchInvoiceReports = useSearchInvoiceReportsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useSearchInvoiceReportsHook>>>
  > = () =>
    searchInvoiceReports(searchInvoiceReportsRequest, params, requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useSearchInvoiceReportsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SearchInvoiceReportsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useSearchInvoiceReportsHook>>>
>;
export type SearchInvoiceReportsSuspenseQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Get a list of invoice reports
 */
export const useSearchInvoiceReportsSuspense = <
  TData = Awaited<ReturnType<ReturnType<typeof useSearchInvoiceReportsHook>>>,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  searchInvoiceReportsRequest: SearchInvoiceReportsRequest,
  params?: SearchInvoiceReportsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useSearchInvoiceReportsHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useSearchInvoiceReportsSuspenseQueryOptions(
    searchInvoiceReportsRequest,
    params,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Deletes an invoice report. Only reports in draft, canceled, or rejected status can be deleted.
Reports in waiting or approved status cannot be deleted.

 * @summary Delete an invoice report
 */
export const useDeleteInvoiceReportHook = () => {
  const deleteInvoiceReport = useCustomClient<void>();

  return (
    id: string,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>
  ) => {
    return deleteInvoiceReport(
      { url: `/api/js/invoice_reports/${id}/destroy`, method: 'DELETE' },
      options
    );
  };
};

export const useDeleteInvoiceReportMutationOptions = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeleteInvoiceReportHook>>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useDeleteInvoiceReportHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const deleteInvoiceReport = useDeleteInvoiceReportHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useDeleteInvoiceReportHook>>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteInvoiceReport(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteInvoiceReportMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useDeleteInvoiceReportHook>>>
>;

export type DeleteInvoiceReportMutationError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Delete an invoice report
 */
export const useDeleteInvoiceReport = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeleteInvoiceReportHook>>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const mutationOptions = useDeleteInvoiceReportMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Get list invoice transactions of invoice report
 */
export const useGetInvoiceTransactionsHook = () => {
  const getInvoiceTransactions = useCustomClient<InvoiceTransactionsResponse>();

  return (
    id: string,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>,
    signal?: AbortSignal
  ) => {
    return getInvoiceTransactions(
      {
        url: `/api/js/invoice_reports/${id}/invoice_transactions`,
        method: 'GET',
        signal,
      },
      options
    );
  };
};

export const getGetInvoiceTransactionsQueryKey = (id: string) => {
  return [`/api/js/invoice_reports/${id}/invoice_transactions`] as const;
};

export const useGetInvoiceTransactionsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetInvoiceTransactionsHook>>>,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetInvoiceTransactionsHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetInvoiceTransactionsQueryKey(id);

  const getInvoiceTransactions = useGetInvoiceTransactionsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetInvoiceTransactionsHook>>>
  > = ({ signal }) => getInvoiceTransactions(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetInvoiceTransactionsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInvoiceTransactionsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetInvoiceTransactionsHook>>>
>;
export type GetInvoiceTransactionsQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Get list invoice transactions of invoice report
 */
export const useGetInvoiceTransactions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetInvoiceTransactionsHook>>>,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetInvoiceTransactionsHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetInvoiceTransactionsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetInvoiceTransactionsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetInvoiceTransactionsHook>>>,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetInvoiceTransactionsHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetInvoiceTransactionsQueryKey(id);

  const getInvoiceTransactions = useGetInvoiceTransactionsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetInvoiceTransactionsHook>>>
  > = ({ signal }) => getInvoiceTransactions(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseSuspenseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetInvoiceTransactionsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInvoiceTransactionsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetInvoiceTransactionsHook>>>
>;
export type GetInvoiceTransactionsSuspenseQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Get list invoice transactions of invoice report
 */
export const useGetInvoiceTransactionsSuspense = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetInvoiceTransactionsHook>>>,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetInvoiceTransactionsHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetInvoiceTransactionsSuspenseQueryOptions(
    id,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Get reference invoice transactions of invoice report (approved invoice reports)
 */
export const useGetReferenceInvoiceTransactionsHook = () => {
  const getReferenceInvoiceTransactions =
    useCustomClient<ReferenceInvoiceTransactionsResponse>();

  return (
    id: string,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>,
    signal?: AbortSignal
  ) => {
    return getReferenceInvoiceTransactions(
      {
        url: `/api/js/invoice_reports/${id}/reference_invoice_transactions`,
        method: 'GET',
        signal,
      },
      options
    );
  };
};

export const getGetReferenceInvoiceTransactionsQueryKey = (id: string) => {
  return [
    `/api/js/invoice_reports/${id}/reference_invoice_transactions`,
  ] as const;
};

export const useGetReferenceInvoiceTransactionsQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetReferenceInvoiceTransactionsHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetReferenceInvoiceTransactionsHook>>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetReferenceInvoiceTransactionsQueryKey(id);

  const getReferenceInvoiceTransactions =
    useGetReferenceInvoiceTransactionsHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<ReturnType<typeof useGetReferenceInvoiceTransactionsHook>>
    >
  > = ({ signal }) =>
    getReferenceInvoiceTransactions(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useGetReferenceInvoiceTransactionsHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetReferenceInvoiceTransactionsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetReferenceInvoiceTransactionsHook>>>
>;
export type GetReferenceInvoiceTransactionsQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Get reference invoice transactions of invoice report (approved invoice reports)
 */
export const useGetReferenceInvoiceTransactions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetReferenceInvoiceTransactionsHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetReferenceInvoiceTransactionsHook>>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetReferenceInvoiceTransactionsQueryOptions(
    id,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetReferenceInvoiceTransactionsSuspenseQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetReferenceInvoiceTransactionsHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetReferenceInvoiceTransactionsHook>>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetReferenceInvoiceTransactionsQueryKey(id);

  const getReferenceInvoiceTransactions =
    useGetReferenceInvoiceTransactionsHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<ReturnType<typeof useGetReferenceInvoiceTransactionsHook>>
    >
  > = ({ signal }) =>
    getReferenceInvoiceTransactions(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseSuspenseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useGetReferenceInvoiceTransactionsHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetReferenceInvoiceTransactionsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetReferenceInvoiceTransactionsHook>>>
>;
export type GetReferenceInvoiceTransactionsSuspenseQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Get reference invoice transactions of invoice report (approved invoice reports)
 */
export const useGetReferenceInvoiceTransactionsSuspense = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetReferenceInvoiceTransactionsHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetReferenceInvoiceTransactionsHook>>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetReferenceInvoiceTransactionsSuspenseQueryOptions(
    id,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Get report summary of an invoice report
 */
export const useGetInvoiceReportSummaryHook = () => {
  const getInvoiceReportSummary =
    useCustomClient<GetInvoiceReportSummaryResponse>();

  return (
    id: string,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>,
    signal?: AbortSignal
  ) => {
    return getInvoiceReportSummary(
      {
        url: `/api/js/invoice_reports/${id}/report_summary`,
        method: 'GET',
        signal,
      },
      options
    );
  };
};

export const getGetInvoiceReportSummaryQueryKey = (id: string) => {
  return [`/api/js/invoice_reports/${id}/report_summary`] as const;
};

export const useGetInvoiceReportSummaryQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetInvoiceReportSummaryHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportSummaryHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetInvoiceReportSummaryQueryKey(id);

  const getInvoiceReportSummary = useGetInvoiceReportSummaryHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportSummaryHook>>>
  > = ({ signal }) => getInvoiceReportSummary(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportSummaryHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInvoiceReportSummaryQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportSummaryHook>>>
>;
export type GetInvoiceReportSummaryQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Get report summary of an invoice report
 */
export const useGetInvoiceReportSummary = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetInvoiceReportSummaryHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportSummaryHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetInvoiceReportSummaryQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetInvoiceReportSummarySuspenseQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetInvoiceReportSummaryHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportSummaryHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetInvoiceReportSummaryQueryKey(id);

  const getInvoiceReportSummary = useGetInvoiceReportSummaryHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportSummaryHook>>>
  > = ({ signal }) => getInvoiceReportSummary(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseSuspenseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportSummaryHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInvoiceReportSummarySuspenseQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportSummaryHook>>>
>;
export type GetInvoiceReportSummarySuspenseQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Get report summary of an invoice report
 */
export const useGetInvoiceReportSummarySuspense = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetInvoiceReportSummaryHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportSummaryHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetInvoiceReportSummarySuspenseQueryOptions(
    id,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Returns payment information for an invoice report in the payment request detail drawer.

 * @summary Get payment info for invoice report
 */
export const useGetInvoiceReportPaymentInfoHook = () => {
  const getInvoiceReportPaymentInfo =
    useCustomClient<InvoiceReportPaymentInfoResponse>();

  return (
    id: string,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>,
    signal?: AbortSignal
  ) => {
    return getInvoiceReportPaymentInfo(
      {
        url: `/api/js/invoice_reports/${id}/payment_info`,
        method: 'GET',
        signal,
      },
      options
    );
  };
};

export const getGetInvoiceReportPaymentInfoQueryKey = (id: string) => {
  return [`/api/js/invoice_reports/${id}/payment_info`] as const;
};

export const useGetInvoiceReportPaymentInfoQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetInvoiceReportPaymentInfoHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetInvoiceReportPaymentInfoHook>>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetInvoiceReportPaymentInfoQueryKey(id);

  const getInvoiceReportPaymentInfo = useGetInvoiceReportPaymentInfoHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportPaymentInfoHook>>>
  > = ({ signal }) => getInvoiceReportPaymentInfo(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportPaymentInfoHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInvoiceReportPaymentInfoQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportPaymentInfoHook>>>
>;
export type GetInvoiceReportPaymentInfoQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Get payment info for invoice report
 */
export const useGetInvoiceReportPaymentInfo = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetInvoiceReportPaymentInfoHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetInvoiceReportPaymentInfoHook>>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetInvoiceReportPaymentInfoQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetInvoiceReportPaymentInfoSuspenseQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetInvoiceReportPaymentInfoHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetInvoiceReportPaymentInfoHook>>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetInvoiceReportPaymentInfoQueryKey(id);

  const getInvoiceReportPaymentInfo = useGetInvoiceReportPaymentInfoHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportPaymentInfoHook>>>
  > = ({ signal }) => getInvoiceReportPaymentInfo(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseSuspenseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportPaymentInfoHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInvoiceReportPaymentInfoSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportPaymentInfoHook>>>
>;
export type GetInvoiceReportPaymentInfoSuspenseQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Get payment info for invoice report
 */
export const useGetInvoiceReportPaymentInfoSuspense = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetInvoiceReportPaymentInfoHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetInvoiceReportPaymentInfoHook>>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetInvoiceReportPaymentInfoSuspenseQueryOptions(
    id,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Get a business document associated with an invoice report. <br/>
**Restricted Access**: Only accessible to the applicant of the invoice report.

 * @summary Get a business document for invoice reports
 */
export const useGetInvoiceReportBusinessDocumentHook = () => {
  const getInvoiceReportBusinessDocument =
    useCustomClient<InvoiceReportBusinessDocumentResponse>();

  return (
    id: string,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>,
    signal?: AbortSignal
  ) => {
    return getInvoiceReportBusinessDocument(
      {
        url: `/api/js/invoice_reports/business_documents/${id}`,
        method: 'GET',
        signal,
      },
      options
    );
  };
};

export const getGetInvoiceReportBusinessDocumentQueryKey = (id: string) => {
  return [`/api/js/invoice_reports/business_documents/${id}`] as const;
};

export const useGetInvoiceReportBusinessDocumentQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetInvoiceReportBusinessDocumentHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetInvoiceReportBusinessDocumentHook>>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetInvoiceReportBusinessDocumentQueryKey(id);

  const getInvoiceReportBusinessDocument =
    useGetInvoiceReportBusinessDocumentHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<ReturnType<typeof useGetInvoiceReportBusinessDocumentHook>>
    >
  > = ({ signal }) =>
    getInvoiceReportBusinessDocument(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useGetInvoiceReportBusinessDocumentHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInvoiceReportBusinessDocumentQueryResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useGetInvoiceReportBusinessDocumentHook>>
  >
>;
export type GetInvoiceReportBusinessDocumentQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Get a business document for invoice reports
 */
export const useGetInvoiceReportBusinessDocument = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetInvoiceReportBusinessDocumentHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetInvoiceReportBusinessDocumentHook>>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetInvoiceReportBusinessDocumentQueryOptions(
    id,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetInvoiceReportBusinessDocumentSuspenseQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetInvoiceReportBusinessDocumentHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetInvoiceReportBusinessDocumentHook>>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetInvoiceReportBusinessDocumentQueryKey(id);

  const getInvoiceReportBusinessDocument =
    useGetInvoiceReportBusinessDocumentHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<ReturnType<typeof useGetInvoiceReportBusinessDocumentHook>>
    >
  > = ({ signal }) =>
    getInvoiceReportBusinessDocument(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseSuspenseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useGetInvoiceReportBusinessDocumentHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInvoiceReportBusinessDocumentSuspenseQueryResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useGetInvoiceReportBusinessDocumentHook>>
  >
>;
export type GetInvoiceReportBusinessDocumentSuspenseQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Get a business document for invoice reports
 */
export const useGetInvoiceReportBusinessDocumentSuspense = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetInvoiceReportBusinessDocumentHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetInvoiceReportBusinessDocumentHook>>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetInvoiceReportBusinessDocumentSuspenseQueryOptions(
    id,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Returns the accounting journal entries for an invoice report in the payment request detail view.

 * @summary Get journal of an invoice report
 */
export const useGetInvoiceReportJournalHook = () => {
  const getInvoiceReportJournal =
    useCustomClient<InvoiceReportJournalResponse>();

  return (
    id: string,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>,
    signal?: AbortSignal
  ) => {
    return getInvoiceReportJournal(
      { url: `/api/js/invoice_reports/${id}/journal`, method: 'GET', signal },
      options
    );
  };
};

export const getGetInvoiceReportJournalQueryKey = (id: string) => {
  return [`/api/js/invoice_reports/${id}/journal`] as const;
};

export const useGetInvoiceReportJournalQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetInvoiceReportJournalHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportJournalHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetInvoiceReportJournalQueryKey(id);

  const getInvoiceReportJournal = useGetInvoiceReportJournalHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportJournalHook>>>
  > = ({ signal }) => getInvoiceReportJournal(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportJournalHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInvoiceReportJournalQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportJournalHook>>>
>;
export type GetInvoiceReportJournalQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Get journal of an invoice report
 */
export const useGetInvoiceReportJournal = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetInvoiceReportJournalHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportJournalHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetInvoiceReportJournalQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetInvoiceReportJournalSuspenseQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetInvoiceReportJournalHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportJournalHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetInvoiceReportJournalQueryKey(id);

  const getInvoiceReportJournal = useGetInvoiceReportJournalHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportJournalHook>>>
  > = ({ signal }) => getInvoiceReportJournal(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseSuspenseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportJournalHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInvoiceReportJournalSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportJournalHook>>>
>;
export type GetInvoiceReportJournalSuspenseQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Get journal of an invoice report
 */
export const useGetInvoiceReportJournalSuspense = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetInvoiceReportJournalHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportJournalHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetInvoiceReportJournalSuspenseQueryOptions(
    id,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Returns approval route for an invoice report.
 * @summary Get approval route for invoice report
 */
export const useGetInvoiceReportApprovalRouteHook = () => {
  const getInvoiceReportApprovalRoute =
    useCustomClient<InvoiceReportApprovalRouteResponse>();

  return (
    id: string,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>,
    signal?: AbortSignal
  ) => {
    return getInvoiceReportApprovalRoute(
      {
        url: `/api/js/invoice_reports/${id}/approval_route`,
        method: 'GET',
        signal,
      },
      options
    );
  };
};

export const getGetInvoiceReportApprovalRouteQueryKey = (id: string) => {
  return [`/api/js/invoice_reports/${id}/approval_route`] as const;
};

export const useGetInvoiceReportApprovalRouteQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetInvoiceReportApprovalRouteHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetInvoiceReportApprovalRouteHook>>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetInvoiceReportApprovalRouteQueryKey(id);

  const getInvoiceReportApprovalRoute = useGetInvoiceReportApprovalRouteHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportApprovalRouteHook>>>
  > = ({ signal }) => getInvoiceReportApprovalRoute(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useGetInvoiceReportApprovalRouteHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInvoiceReportApprovalRouteQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportApprovalRouteHook>>>
>;
export type GetInvoiceReportApprovalRouteQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Get approval route for invoice report
 */
export const useGetInvoiceReportApprovalRoute = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetInvoiceReportApprovalRouteHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetInvoiceReportApprovalRouteHook>>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetInvoiceReportApprovalRouteQueryOptions(
    id,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetInvoiceReportApprovalRouteSuspenseQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetInvoiceReportApprovalRouteHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetInvoiceReportApprovalRouteHook>>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetInvoiceReportApprovalRouteQueryKey(id);

  const getInvoiceReportApprovalRoute = useGetInvoiceReportApprovalRouteHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportApprovalRouteHook>>>
  > = ({ signal }) => getInvoiceReportApprovalRoute(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseSuspenseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useGetInvoiceReportApprovalRouteHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInvoiceReportApprovalRouteSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportApprovalRouteHook>>>
>;
export type GetInvoiceReportApprovalRouteSuspenseQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Get approval route for invoice report
 */
export const useGetInvoiceReportApprovalRouteSuspense = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetInvoiceReportApprovalRouteHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetInvoiceReportApprovalRouteHook>>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetInvoiceReportApprovalRouteSuspenseQueryOptions(
    id,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Get report summary of an invoice report
 */
export const useGetReportSummaryHook = () => {
  const getReportSummary =
    useCustomClient<InvoiceReportDetailReportSummaryResponse>();

  return (
    id: string,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>,
    signal?: AbortSignal
  ) => {
    return getReportSummary(
      {
        url: `/api/js/invoice_reports/approving_invoice_reports/${id}/report_summary`,
        method: 'GET',
        signal,
      },
      options
    );
  };
};

export const getGetReportSummaryQueryKey = (id: string) => {
  return [
    `/api/js/invoice_reports/approving_invoice_reports/${id}/report_summary`,
  ] as const;
};

export const useGetReportSummaryQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetReportSummaryHook>>>,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetReportSummaryHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReportSummaryQueryKey(id);

  const getReportSummary = useGetReportSummaryHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetReportSummaryHook>>>
  > = ({ signal }) => getReportSummary(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetReportSummaryHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetReportSummaryQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetReportSummaryHook>>>
>;
export type GetReportSummaryQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Get report summary of an invoice report
 */
export const useGetReportSummary = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetReportSummaryHook>>>,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetReportSummaryHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetReportSummaryQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetReportSummarySuspenseQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetReportSummaryHook>>>,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetReportSummaryHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReportSummaryQueryKey(id);

  const getReportSummary = useGetReportSummaryHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetReportSummaryHook>>>
  > = ({ signal }) => getReportSummary(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseSuspenseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetReportSummaryHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetReportSummarySuspenseQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetReportSummaryHook>>>
>;
export type GetReportSummarySuspenseQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Get report summary of an invoice report
 */
export const useGetReportSummarySuspense = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetReportSummaryHook>>>,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetReportSummaryHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetReportSummarySuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Get recent approved invoice reports for a specific payee
 */
export const useGetReferenceRecentApprovedInvoiceReportsHook = () => {
  const getReferenceRecentApprovedInvoiceReports =
    useCustomClient<ReferenceRecentApprovedInvoiceReportsResponse>();

  return (
    params: GetReferenceRecentApprovedInvoiceReportsParams,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>,
    signal?: AbortSignal
  ) => {
    return getReferenceRecentApprovedInvoiceReports(
      {
        url: `/api/js/invoice_reports/reference_recent_approved`,
        method: 'GET',
        params,
        signal,
      },
      options
    );
  };
};

export const getGetReferenceRecentApprovedInvoiceReportsQueryKey = (
  params: GetReferenceRecentApprovedInvoiceReportsParams
) => {
  return [
    `/api/js/invoice_reports/reference_recent_approved`,
    ...(params ? [params] : []),
  ] as const;
};

export const useGetReferenceRecentApprovedInvoiceReportsQueryOptions = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useGetReferenceRecentApprovedInvoiceReportsHook>
    >
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  params: GetReferenceRecentApprovedInvoiceReportsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useGetReferenceRecentApprovedInvoiceReportsHook>
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetReferenceRecentApprovedInvoiceReportsQueryKey(params);

  const getReferenceRecentApprovedInvoiceReports =
    useGetReferenceRecentApprovedInvoiceReportsHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useGetReferenceRecentApprovedInvoiceReportsHook>
      >
    >
  > = ({ signal }) =>
    getReferenceRecentApprovedInvoiceReports(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useGetReferenceRecentApprovedInvoiceReportsHook>
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetReferenceRecentApprovedInvoiceReportsQueryResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof useGetReferenceRecentApprovedInvoiceReportsHook>
    >
  >
>;
export type GetReferenceRecentApprovedInvoiceReportsQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Get recent approved invoice reports for a specific payee
 */
export const useGetReferenceRecentApprovedInvoiceReports = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useGetReferenceRecentApprovedInvoiceReportsHook>
    >
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  params: GetReferenceRecentApprovedInvoiceReportsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useGetReferenceRecentApprovedInvoiceReportsHook>
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetReferenceRecentApprovedInvoiceReportsQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetReferenceRecentApprovedInvoiceReportsSuspenseQueryOptions = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useGetReferenceRecentApprovedInvoiceReportsHook>
    >
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  params: GetReferenceRecentApprovedInvoiceReportsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useGetReferenceRecentApprovedInvoiceReportsHook>
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetReferenceRecentApprovedInvoiceReportsQueryKey(params);

  const getReferenceRecentApprovedInvoiceReports =
    useGetReferenceRecentApprovedInvoiceReportsHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useGetReferenceRecentApprovedInvoiceReportsHook>
      >
    >
  > = ({ signal }) =>
    getReferenceRecentApprovedInvoiceReports(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useGetReferenceRecentApprovedInvoiceReportsHook>
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetReferenceRecentApprovedInvoiceReportsSuspenseQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<typeof useGetReferenceRecentApprovedInvoiceReportsHook>
      >
    >
  >;
export type GetReferenceRecentApprovedInvoiceReportsSuspenseQueryError =
  ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >;

/**
 * @summary Get recent approved invoice reports for a specific payee
 */
export const useGetReferenceRecentApprovedInvoiceReportsSuspense = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useGetReferenceRecentApprovedInvoiceReportsHook>
    >
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  params: GetReferenceRecentApprovedInvoiceReportsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useGetReferenceRecentApprovedInvoiceReportsHook>
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useGetReferenceRecentApprovedInvoiceReportsSuspenseQueryOptions(
      params,
      options
    );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Get a list of approving invoice reports
 */
export const useSearchApprovingInvoiceReportsHook = () => {
  const searchApprovingInvoiceReports = useCustomClient<
    SearchApprovingInvoiceReportsResponse | Blob
  >();

  return (
    searchApprovingInvoiceReportsRequest: BodyType<SearchApprovingInvoiceReportsRequest>,
    params?: SearchApprovingInvoiceReportsParams,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>
  ) => {
    return searchApprovingInvoiceReports(
      {
        url: `/api/js/invoice_reports/approving_invoice_reports/search`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: searchApprovingInvoiceReportsRequest,
        params,
      },
      options
    );
  };
};

export const getSearchApprovingInvoiceReportsQueryKey = (
  searchApprovingInvoiceReportsRequest: SearchApprovingInvoiceReportsRequest,
  params?: SearchApprovingInvoiceReportsParams
) => {
  return [
    `/api/js/invoice_reports/approving_invoice_reports/search`,
    ...(params ? [params] : []),
    searchApprovingInvoiceReportsRequest,
  ] as const;
};

export const useSearchApprovingInvoiceReportsQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useSearchApprovingInvoiceReportsHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  searchApprovingInvoiceReportsRequest: SearchApprovingInvoiceReportsRequest,
  params?: SearchApprovingInvoiceReportsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useSearchApprovingInvoiceReportsHook>>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSearchApprovingInvoiceReportsQueryKey(
      searchApprovingInvoiceReportsRequest,
      params
    );

  const searchApprovingInvoiceReports = useSearchApprovingInvoiceReportsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useSearchApprovingInvoiceReportsHook>>>
  > = () =>
    searchApprovingInvoiceReports(
      searchApprovingInvoiceReportsRequest,
      params,
      requestOptions
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useSearchApprovingInvoiceReportsHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SearchApprovingInvoiceReportsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useSearchApprovingInvoiceReportsHook>>>
>;
export type SearchApprovingInvoiceReportsQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Get a list of approving invoice reports
 */
export const useSearchApprovingInvoiceReports = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useSearchApprovingInvoiceReportsHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  searchApprovingInvoiceReportsRequest: SearchApprovingInvoiceReportsRequest,
  params?: SearchApprovingInvoiceReportsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useSearchApprovingInvoiceReportsHook>>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useSearchApprovingInvoiceReportsQueryOptions(
    searchApprovingInvoiceReportsRequest,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useSearchApprovingInvoiceReportsSuspenseQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useSearchApprovingInvoiceReportsHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  searchApprovingInvoiceReportsRequest: SearchApprovingInvoiceReportsRequest,
  params?: SearchApprovingInvoiceReportsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useSearchApprovingInvoiceReportsHook>>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSearchApprovingInvoiceReportsQueryKey(
      searchApprovingInvoiceReportsRequest,
      params
    );

  const searchApprovingInvoiceReports = useSearchApprovingInvoiceReportsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useSearchApprovingInvoiceReportsHook>>>
  > = () =>
    searchApprovingInvoiceReports(
      searchApprovingInvoiceReportsRequest,
      params,
      requestOptions
    );

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useSearchApprovingInvoiceReportsHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SearchApprovingInvoiceReportsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useSearchApprovingInvoiceReportsHook>>>
>;
export type SearchApprovingInvoiceReportsSuspenseQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Get a list of approving invoice reports
 */
export const useSearchApprovingInvoiceReportsSuspense = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useSearchApprovingInvoiceReportsHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  searchApprovingInvoiceReportsRequest: SearchApprovingInvoiceReportsRequest,
  params?: SearchApprovingInvoiceReportsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useSearchApprovingInvoiceReportsHook>>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useSearchApprovingInvoiceReportsSuspenseQueryOptions(
    searchApprovingInvoiceReportsRequest,
    params,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Get journal of an invoice report
 */
export const useGetApprovingInvoiceReportJournalHook = () => {
  const getApprovingInvoiceReportJournal =
    useCustomClient<GetApprovingInvoiceReportJournal200>();

  return (
    id: string,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>,
    signal?: AbortSignal
  ) => {
    return getApprovingInvoiceReportJournal(
      {
        url: `/api/js/invoice_reports/approving_invoice_reports/${id}/journal`,
        method: 'GET',
        signal,
      },
      options
    );
  };
};

export const getGetApprovingInvoiceReportJournalQueryKey = (id: string) => {
  return [
    `/api/js/invoice_reports/approving_invoice_reports/${id}/journal`,
  ] as const;
};

export const useGetApprovingInvoiceReportJournalQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetApprovingInvoiceReportJournalHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetApprovingInvoiceReportJournalHook>>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApprovingInvoiceReportJournalQueryKey(id);

  const getApprovingInvoiceReportJournal =
    useGetApprovingInvoiceReportJournalHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<ReturnType<typeof useGetApprovingInvoiceReportJournalHook>>
    >
  > = ({ signal }) =>
    getApprovingInvoiceReportJournal(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useGetApprovingInvoiceReportJournalHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApprovingInvoiceReportJournalQueryResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useGetApprovingInvoiceReportJournalHook>>
  >
>;
export type GetApprovingInvoiceReportJournalQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Get journal of an invoice report
 */
export const useGetApprovingInvoiceReportJournal = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetApprovingInvoiceReportJournalHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetApprovingInvoiceReportJournalHook>>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetApprovingInvoiceReportJournalQueryOptions(
    id,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetApprovingInvoiceReportJournalSuspenseQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetApprovingInvoiceReportJournalHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetApprovingInvoiceReportJournalHook>>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApprovingInvoiceReportJournalQueryKey(id);

  const getApprovingInvoiceReportJournal =
    useGetApprovingInvoiceReportJournalHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<ReturnType<typeof useGetApprovingInvoiceReportJournalHook>>
    >
  > = ({ signal }) =>
    getApprovingInvoiceReportJournal(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseSuspenseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useGetApprovingInvoiceReportJournalHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApprovingInvoiceReportJournalSuspenseQueryResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useGetApprovingInvoiceReportJournalHook>>
  >
>;
export type GetApprovingInvoiceReportJournalSuspenseQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Get journal of an invoice report
 */
export const useGetApprovingInvoiceReportJournalSuspense = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetApprovingInvoiceReportJournalHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetApprovingInvoiceReportJournalHook>>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetApprovingInvoiceReportJournalSuspenseQueryOptions(
    id,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Get invoice transactions of an approving invoice report
 */
export const useGetApprovingInvoiceReportInvoiceTransactionsHook = () => {
  const getApprovingInvoiceReportInvoiceTransactions =
    useCustomClient<GetApprovingInvoiceReportInvoiceTransactions200>();

  return (
    id: string,
    params?: GetApprovingInvoiceReportInvoiceTransactionsParams,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>
  ) => {
    return getApprovingInvoiceReportInvoiceTransactions(
      {
        url: `/api/js/invoice_reports/approving_invoice_reports/${id}/invoice_transactions`,
        method: 'GET',
        params,
      },
      options
    );
  };
};

export const getGetApprovingInvoiceReportInvoiceTransactionsQueryKey = (
  id: string,
  params?: GetApprovingInvoiceReportInvoiceTransactionsParams
) => {
  return [
    `/api/js/invoice_reports/approving_invoice_reports/${id}/invoice_transactions`,
    ...(params ? [params] : []),
  ] as const;
};

export const useGetApprovingInvoiceReportInvoiceTransactionsInfiniteQueryOptions =
  <
    TData = InfiniteData<
      Awaited<
        ReturnType<
          ReturnType<typeof useGetApprovingInvoiceReportInvoiceTransactionsHook>
        >
      >,
      GetApprovingInvoiceReportInvoiceTransactionsParams['offset']
    >,
    TError = ErrorType<
      | BadRequestResponse
      | UnauthorizedResponse
      | ForbiddenResponse
      | NotFoundResponse
      | UnprocessableEntityResponse
    >
  >(
    id: string,
    params?: GetApprovingInvoiceReportInvoiceTransactionsParams,
    options?: {
      query?: Partial<
        UseInfiniteQueryOptions<
          Awaited<
            ReturnType<
              ReturnType<
                typeof useGetApprovingInvoiceReportInvoiceTransactionsHook
              >
            >
          >,
          TError,
          TData,
          Awaited<
            ReturnType<
              ReturnType<
                typeof useGetApprovingInvoiceReportInvoiceTransactionsHook
              >
            >
          >,
          QueryKey,
          GetApprovingInvoiceReportInvoiceTransactionsParams['offset']
        >
      >;
      request?: SecondParameter<ReturnType<typeof useCustomClient>>;
    }
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetApprovingInvoiceReportInvoiceTransactionsQueryKey(id, params);

    const getApprovingInvoiceReportInvoiceTransactions =
      useGetApprovingInvoiceReportInvoiceTransactionsHook();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          ReturnType<typeof useGetApprovingInvoiceReportInvoiceTransactionsHook>
        >
      >,
      QueryKey,
      GetApprovingInvoiceReportInvoiceTransactionsParams['offset']
    > = ({ pageParam }) =>
      getApprovingInvoiceReportInvoiceTransactions(
        id,
        { ...params, offset: pageParam || params?.['offset'] },
        requestOptions
      );

    return {
      queryKey,
      queryFn,
      enabled: !!id,
      ...queryOptions,
    } as UseInfiniteQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useGetApprovingInvoiceReportInvoiceTransactionsHook>
        >
      >,
      TError,
      TData,
      Awaited<
        ReturnType<
          ReturnType<typeof useGetApprovingInvoiceReportInvoiceTransactionsHook>
        >
      >,
      QueryKey,
      GetApprovingInvoiceReportInvoiceTransactionsParams['offset']
    > & { queryKey: QueryKey };
  };

export type GetApprovingInvoiceReportInvoiceTransactionsInfiniteQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<typeof useGetApprovingInvoiceReportInvoiceTransactionsHook>
      >
    >
  >;
export type GetApprovingInvoiceReportInvoiceTransactionsInfiniteQueryError =
  ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >;

/**
 * @summary Get invoice transactions of an approving invoice report
 */
export const useGetApprovingInvoiceReportInvoiceTransactionsInfinite = <
  TData = InfiniteData<
    Awaited<
      ReturnType<
        ReturnType<typeof useGetApprovingInvoiceReportInvoiceTransactionsHook>
      >
    >,
    GetApprovingInvoiceReportInvoiceTransactionsParams['offset']
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  params?: GetApprovingInvoiceReportInvoiceTransactionsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<
              typeof useGetApprovingInvoiceReportInvoiceTransactionsHook
            >
          >
        >,
        TError,
        TData,
        Awaited<
          ReturnType<
            ReturnType<
              typeof useGetApprovingInvoiceReportInvoiceTransactionsHook
            >
          >
        >,
        QueryKey,
        GetApprovingInvoiceReportInvoiceTransactionsParams['offset']
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useGetApprovingInvoiceReportInvoiceTransactionsInfiniteQueryOptions(
      id,
      params,
      options
    );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetApprovingInvoiceReportInvoiceTransactionsQueryOptions = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useGetApprovingInvoiceReportInvoiceTransactionsHook>
    >
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  params?: GetApprovingInvoiceReportInvoiceTransactionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<
              typeof useGetApprovingInvoiceReportInvoiceTransactionsHook
            >
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApprovingInvoiceReportInvoiceTransactionsQueryKey(id, params);

  const getApprovingInvoiceReportInvoiceTransactions =
    useGetApprovingInvoiceReportInvoiceTransactionsHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useGetApprovingInvoiceReportInvoiceTransactionsHook>
      >
    >
  > = () =>
    getApprovingInvoiceReportInvoiceTransactions(id, params, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useGetApprovingInvoiceReportInvoiceTransactionsHook>
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApprovingInvoiceReportInvoiceTransactionsQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<typeof useGetApprovingInvoiceReportInvoiceTransactionsHook>
      >
    >
  >;
export type GetApprovingInvoiceReportInvoiceTransactionsQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Get invoice transactions of an approving invoice report
 */
export const useGetApprovingInvoiceReportInvoiceTransactions = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useGetApprovingInvoiceReportInvoiceTransactionsHook>
    >
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  params?: GetApprovingInvoiceReportInvoiceTransactionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<
              typeof useGetApprovingInvoiceReportInvoiceTransactionsHook
            >
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useGetApprovingInvoiceReportInvoiceTransactionsQueryOptions(
      id,
      params,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetApprovingInvoiceReportInvoiceTransactionsSuspenseQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        ReturnType<typeof useGetApprovingInvoiceReportInvoiceTransactionsHook>
      >
    >,
    TError = ErrorType<
      | BadRequestResponse
      | UnauthorizedResponse
      | ForbiddenResponse
      | NotFoundResponse
      | UnprocessableEntityResponse
    >
  >(
    id: string,
    params?: GetApprovingInvoiceReportInvoiceTransactionsParams,
    options?: {
      query?: Partial<
        UseSuspenseQueryOptions<
          Awaited<
            ReturnType<
              ReturnType<
                typeof useGetApprovingInvoiceReportInvoiceTransactionsHook
              >
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<ReturnType<typeof useCustomClient>>;
    }
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetApprovingInvoiceReportInvoiceTransactionsQueryKey(id, params);

    const getApprovingInvoiceReportInvoiceTransactions =
      useGetApprovingInvoiceReportInvoiceTransactionsHook();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          ReturnType<typeof useGetApprovingInvoiceReportInvoiceTransactionsHook>
        >
      >
    > = () =>
      getApprovingInvoiceReportInvoiceTransactions(id, params, requestOptions);

    return {
      queryKey,
      queryFn,
      enabled: !!id,
      ...queryOptions,
    } as UseSuspenseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useGetApprovingInvoiceReportInvoiceTransactionsHook>
        >
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type GetApprovingInvoiceReportInvoiceTransactionsSuspenseQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<typeof useGetApprovingInvoiceReportInvoiceTransactionsHook>
      >
    >
  >;
export type GetApprovingInvoiceReportInvoiceTransactionsSuspenseQueryError =
  ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >;

/**
 * @summary Get invoice transactions of an approving invoice report
 */
export const useGetApprovingInvoiceReportInvoiceTransactionsSuspense = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useGetApprovingInvoiceReportInvoiceTransactionsHook>
    >
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  params?: GetApprovingInvoiceReportInvoiceTransactionsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<
              typeof useGetApprovingInvoiceReportInvoiceTransactionsHook
            >
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useGetApprovingInvoiceReportInvoiceTransactionsSuspenseQueryOptions(
      id,
      params,
      options
    );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetApprovingInvoiceReportInvoiceTransactionsSuspenseInfiniteQueryOptions =
  <
    TData = InfiniteData<
      Awaited<
        ReturnType<
          ReturnType<typeof useGetApprovingInvoiceReportInvoiceTransactionsHook>
        >
      >,
      GetApprovingInvoiceReportInvoiceTransactionsParams['offset']
    >,
    TError = ErrorType<
      | BadRequestResponse
      | UnauthorizedResponse
      | ForbiddenResponse
      | NotFoundResponse
      | UnprocessableEntityResponse
    >
  >(
    id: string,
    params?: GetApprovingInvoiceReportInvoiceTransactionsParams,
    options?: {
      query?: Partial<
        UseSuspenseInfiniteQueryOptions<
          Awaited<
            ReturnType<
              ReturnType<
                typeof useGetApprovingInvoiceReportInvoiceTransactionsHook
              >
            >
          >,
          TError,
          TData,
          Awaited<
            ReturnType<
              ReturnType<
                typeof useGetApprovingInvoiceReportInvoiceTransactionsHook
              >
            >
          >,
          QueryKey,
          GetApprovingInvoiceReportInvoiceTransactionsParams['offset']
        >
      >;
      request?: SecondParameter<ReturnType<typeof useCustomClient>>;
    }
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetApprovingInvoiceReportInvoiceTransactionsQueryKey(id, params);

    const getApprovingInvoiceReportInvoiceTransactions =
      useGetApprovingInvoiceReportInvoiceTransactionsHook();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          ReturnType<typeof useGetApprovingInvoiceReportInvoiceTransactionsHook>
        >
      >,
      QueryKey,
      GetApprovingInvoiceReportInvoiceTransactionsParams['offset']
    > = ({ pageParam }) =>
      getApprovingInvoiceReportInvoiceTransactions(
        id,
        { ...params, offset: pageParam || params?.['offset'] },
        requestOptions
      );

    return {
      queryKey,
      queryFn,
      enabled: !!id,
      ...queryOptions,
    } as UseSuspenseInfiniteQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useGetApprovingInvoiceReportInvoiceTransactionsHook>
        >
      >,
      TError,
      TData,
      Awaited<
        ReturnType<
          ReturnType<typeof useGetApprovingInvoiceReportInvoiceTransactionsHook>
        >
      >,
      QueryKey,
      GetApprovingInvoiceReportInvoiceTransactionsParams['offset']
    > & { queryKey: QueryKey };
  };

export type GetApprovingInvoiceReportInvoiceTransactionsSuspenseInfiniteQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<typeof useGetApprovingInvoiceReportInvoiceTransactionsHook>
      >
    >
  >;
export type GetApprovingInvoiceReportInvoiceTransactionsSuspenseInfiniteQueryError =
  ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >;

/**
 * @summary Get invoice transactions of an approving invoice report
 */
export const useGetApprovingInvoiceReportInvoiceTransactionsSuspenseInfinite = <
  TData = InfiniteData<
    Awaited<
      ReturnType<
        ReturnType<typeof useGetApprovingInvoiceReportInvoiceTransactionsHook>
      >
    >,
    GetApprovingInvoiceReportInvoiceTransactionsParams['offset']
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  params?: GetApprovingInvoiceReportInvoiceTransactionsParams,
  options?: {
    query?: Partial<
      UseSuspenseInfiniteQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<
              typeof useGetApprovingInvoiceReportInvoiceTransactionsHook
            >
          >
        >,
        TError,
        TData,
        Awaited<
          ReturnType<
            ReturnType<
              typeof useGetApprovingInvoiceReportInvoiceTransactionsHook
            >
          >
        >,
        QueryKey,
        GetApprovingInvoiceReportInvoiceTransactionsParams['offset']
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useGetApprovingInvoiceReportInvoiceTransactionsSuspenseInfiniteQueryOptions(
      id,
      params,
      options
    );

  const query = useSuspenseInfiniteQuery(
    queryOptions
  ) as UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Returns payment information for an invoice report in the approval view detail drawer.
**Restricted Access**: Only accessible to approvers and administrators.

 * @summary Get payment info for approving invoice report
 */
export const useGetApprovingInvoiceReportPaymentInfoHook = () => {
  const getApprovingInvoiceReportPaymentInfo =
    useCustomClient<ApprovingInvoiceReportPaymentInfoResponse>();

  return (
    id: string,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>,
    signal?: AbortSignal
  ) => {
    return getApprovingInvoiceReportPaymentInfo(
      {
        url: `/api/js/invoice_reports/approving_invoice_reports/${id}/payment_info`,
        method: 'GET',
        signal,
      },
      options
    );
  };
};

export const getGetApprovingInvoiceReportPaymentInfoQueryKey = (id: string) => {
  return [
    `/api/js/invoice_reports/approving_invoice_reports/${id}/payment_info`,
  ] as const;
};

export const useGetApprovingInvoiceReportPaymentInfoQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetApprovingInvoiceReportPaymentInfoHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useGetApprovingInvoiceReportPaymentInfoHook>
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApprovingInvoiceReportPaymentInfoQueryKey(id);

  const getApprovingInvoiceReportPaymentInfo =
    useGetApprovingInvoiceReportPaymentInfoHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<ReturnType<typeof useGetApprovingInvoiceReportPaymentInfoHook>>
    >
  > = ({ signal }) =>
    getApprovingInvoiceReportPaymentInfo(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useGetApprovingInvoiceReportPaymentInfoHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApprovingInvoiceReportPaymentInfoQueryResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useGetApprovingInvoiceReportPaymentInfoHook>>
  >
>;
export type GetApprovingInvoiceReportPaymentInfoQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Get payment info for approving invoice report
 */
export const useGetApprovingInvoiceReportPaymentInfo = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetApprovingInvoiceReportPaymentInfoHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useGetApprovingInvoiceReportPaymentInfoHook>
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetApprovingInvoiceReportPaymentInfoQueryOptions(
    id,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetApprovingInvoiceReportPaymentInfoSuspenseQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetApprovingInvoiceReportPaymentInfoHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useGetApprovingInvoiceReportPaymentInfoHook>
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApprovingInvoiceReportPaymentInfoQueryKey(id);

  const getApprovingInvoiceReportPaymentInfo =
    useGetApprovingInvoiceReportPaymentInfoHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<ReturnType<typeof useGetApprovingInvoiceReportPaymentInfoHook>>
    >
  > = ({ signal }) =>
    getApprovingInvoiceReportPaymentInfo(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseSuspenseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useGetApprovingInvoiceReportPaymentInfoHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApprovingInvoiceReportPaymentInfoSuspenseQueryResult =
  NonNullable<
    Awaited<
      ReturnType<ReturnType<typeof useGetApprovingInvoiceReportPaymentInfoHook>>
    >
  >;
export type GetApprovingInvoiceReportPaymentInfoSuspenseQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Get payment info for approving invoice report
 */
export const useGetApprovingInvoiceReportPaymentInfoSuspense = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetApprovingInvoiceReportPaymentInfoHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useGetApprovingInvoiceReportPaymentInfoHook>
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useGetApprovingInvoiceReportPaymentInfoSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Returns approval route for an approving invoice report.
**Restricted Access**: Only accessible to approvers and administrators.

 * @summary Get approval route for approving invoice report
 */
export const useGetApprovingInvoiceReportApprovalRouteHook = () => {
  const getApprovingInvoiceReportApprovalRoute =
    useCustomClient<ApprovingInvoiceReportApprovalRouteResponse>();

  return (
    id: string,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>,
    signal?: AbortSignal
  ) => {
    return getApprovingInvoiceReportApprovalRoute(
      {
        url: `/api/js/invoice_reports/approving_invoice_reports/${id}/approval_route`,
        method: 'GET',
        signal,
      },
      options
    );
  };
};

export const getGetApprovingInvoiceReportApprovalRouteQueryKey = (
  id: string
) => {
  return [
    `/api/js/invoice_reports/approving_invoice_reports/${id}/approval_route`,
  ] as const;
};

export const useGetApprovingInvoiceReportApprovalRouteQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetApprovingInvoiceReportApprovalRouteHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useGetApprovingInvoiceReportApprovalRouteHook>
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApprovingInvoiceReportApprovalRouteQueryKey(id);

  const getApprovingInvoiceReportApprovalRoute =
    useGetApprovingInvoiceReportApprovalRouteHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useGetApprovingInvoiceReportApprovalRouteHook>
      >
    >
  > = ({ signal }) =>
    getApprovingInvoiceReportApprovalRoute(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useGetApprovingInvoiceReportApprovalRouteHook>
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApprovingInvoiceReportApprovalRouteQueryResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useGetApprovingInvoiceReportApprovalRouteHook>>
  >
>;
export type GetApprovingInvoiceReportApprovalRouteQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Get approval route for approving invoice report
 */
export const useGetApprovingInvoiceReportApprovalRoute = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetApprovingInvoiceReportApprovalRouteHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useGetApprovingInvoiceReportApprovalRouteHook>
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetApprovingInvoiceReportApprovalRouteQueryOptions(
    id,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetApprovingInvoiceReportApprovalRouteSuspenseQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetApprovingInvoiceReportApprovalRouteHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useGetApprovingInvoiceReportApprovalRouteHook>
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApprovingInvoiceReportApprovalRouteQueryKey(id);

  const getApprovingInvoiceReportApprovalRoute =
    useGetApprovingInvoiceReportApprovalRouteHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useGetApprovingInvoiceReportApprovalRouteHook>
      >
    >
  > = ({ signal }) =>
    getApprovingInvoiceReportApprovalRoute(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseSuspenseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useGetApprovingInvoiceReportApprovalRouteHook>
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApprovingInvoiceReportApprovalRouteSuspenseQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<typeof useGetApprovingInvoiceReportApprovalRouteHook>
      >
    >
  >;
export type GetApprovingInvoiceReportApprovalRouteSuspenseQueryError =
  ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >;

/**
 * @summary Get approval route for approving invoice report
 */
export const useGetApprovingInvoiceReportApprovalRouteSuspense = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetApprovingInvoiceReportApprovalRouteHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useGetApprovingInvoiceReportApprovalRouteHook>
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useGetApprovingInvoiceReportApprovalRouteSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Get a list of returnable destinations for an approving invoice report and returns status. <br/>
**Restricted Access**: Only accessible to approvers and administrators.

 * @summary Get a list of returnable destinations for an approving invoice report
 */
export const useGetApprovingInvoiceReportDisapprovalRouteHook = () => {
  const getApprovingInvoiceReportDisapprovalRoute =
    useCustomClient<ApprovingInvoiceReportDisapprovalRouteResponse>();

  return (
    id: string,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>,
    signal?: AbortSignal
  ) => {
    return getApprovingInvoiceReportDisapprovalRoute(
      {
        url: `/api/js/invoice_reports/approving_invoice_reports/${id}/disapproval_route`,
        method: 'GET',
        signal,
      },
      options
    );
  };
};

export const getGetApprovingInvoiceReportDisapprovalRouteQueryKey = (
  id: string
) => {
  return [
    `/api/js/invoice_reports/approving_invoice_reports/${id}/disapproval_route`,
  ] as const;
};

export const useGetApprovingInvoiceReportDisapprovalRouteQueryOptions = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useGetApprovingInvoiceReportDisapprovalRouteHook>
    >
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useGetApprovingInvoiceReportDisapprovalRouteHook>
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApprovingInvoiceReportDisapprovalRouteQueryKey(id);

  const getApprovingInvoiceReportDisapprovalRoute =
    useGetApprovingInvoiceReportDisapprovalRouteHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useGetApprovingInvoiceReportDisapprovalRouteHook>
      >
    >
  > = ({ signal }) =>
    getApprovingInvoiceReportDisapprovalRoute(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useGetApprovingInvoiceReportDisapprovalRouteHook>
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApprovingInvoiceReportDisapprovalRouteQueryResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof useGetApprovingInvoiceReportDisapprovalRouteHook>
    >
  >
>;
export type GetApprovingInvoiceReportDisapprovalRouteQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Get a list of returnable destinations for an approving invoice report
 */
export const useGetApprovingInvoiceReportDisapprovalRoute = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useGetApprovingInvoiceReportDisapprovalRouteHook>
    >
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useGetApprovingInvoiceReportDisapprovalRouteHook>
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetApprovingInvoiceReportDisapprovalRouteQueryOptions(
    id,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetApprovingInvoiceReportDisapprovalRouteSuspenseQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        ReturnType<typeof useGetApprovingInvoiceReportDisapprovalRouteHook>
      >
    >,
    TError = ErrorType<
      | BadRequestResponse
      | UnauthorizedResponse
      | ForbiddenResponse
      | NotFoundResponse
      | UnprocessableEntityResponse
    >
  >(
    id: string,
    options?: {
      query?: Partial<
        UseSuspenseQueryOptions<
          Awaited<
            ReturnType<
              ReturnType<
                typeof useGetApprovingInvoiceReportDisapprovalRouteHook
              >
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<ReturnType<typeof useCustomClient>>;
    }
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetApprovingInvoiceReportDisapprovalRouteQueryKey(id);

    const getApprovingInvoiceReportDisapprovalRoute =
      useGetApprovingInvoiceReportDisapprovalRouteHook();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          ReturnType<typeof useGetApprovingInvoiceReportDisapprovalRouteHook>
        >
      >
    > = ({ signal }) =>
      getApprovingInvoiceReportDisapprovalRoute(id, requestOptions, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!id,
      ...queryOptions,
    } as UseSuspenseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useGetApprovingInvoiceReportDisapprovalRouteHook>
        >
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type GetApprovingInvoiceReportDisapprovalRouteSuspenseQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<typeof useGetApprovingInvoiceReportDisapprovalRouteHook>
      >
    >
  >;
export type GetApprovingInvoiceReportDisapprovalRouteSuspenseQueryError =
  ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >;

/**
 * @summary Get a list of returnable destinations for an approving invoice report
 */
export const useGetApprovingInvoiceReportDisapprovalRouteSuspense = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useGetApprovingInvoiceReportDisapprovalRouteHook>
    >
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useGetApprovingInvoiceReportDisapprovalRouteHook>
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useGetApprovingInvoiceReportDisapprovalRouteSuspenseQueryOptions(
      id,
      options
    );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Creates an approval for an approving invoice report and returns status

**Restricted Access**: Only accessible to approvers and administrators.

 * @summary Create an approval for an approving invoice report
 */
export const useCreateApprovingInvoiceReportApprovalHook = () => {
  const createApprovingInvoiceReportApproval =
    useCustomClient<ApprovingInvoiceReportApprovalResponse>();

  return (
    id: string,
    createApprovingInvoiceReportApprovalRequest: BodyType<CreateApprovingInvoiceReportApprovalRequest>,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>
  ) => {
    return createApprovingInvoiceReportApproval(
      {
        url: `/api/js/invoice_reports/approving_invoice_reports/${id}/approval`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createApprovingInvoiceReportApprovalRequest,
      },
      options
    );
  };
};

export const useCreateApprovingInvoiceReportApprovalMutationOptions = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useCreateApprovingInvoiceReportApprovalHook>>
    >,
    TError,
    { id: string; data: BodyType<CreateApprovingInvoiceReportApprovalRequest> },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useCreateApprovingInvoiceReportApprovalHook>>
  >,
  TError,
  { id: string; data: BodyType<CreateApprovingInvoiceReportApprovalRequest> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const createApprovingInvoiceReportApproval =
    useCreateApprovingInvoiceReportApprovalHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useCreateApprovingInvoiceReportApprovalHook>>
    >,
    { id: string; data: BodyType<CreateApprovingInvoiceReportApprovalRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return createApprovingInvoiceReportApproval(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateApprovingInvoiceReportApprovalMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useCreateApprovingInvoiceReportApprovalHook>>
  >
>;
export type CreateApprovingInvoiceReportApprovalMutationBody =
  BodyType<CreateApprovingInvoiceReportApprovalRequest>;
export type CreateApprovingInvoiceReportApprovalMutationError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Create an approval for an approving invoice report
 */
export const useCreateApprovingInvoiceReportApproval = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useCreateApprovingInvoiceReportApprovalHook>>
    >,
    TError,
    { id: string; data: BodyType<CreateApprovingInvoiceReportApprovalRequest> },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const mutationOptions =
    useCreateApprovingInvoiceReportApprovalMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Approves multiple invoice reports in a single request.
Each report can have an optional approval message.

**Restricted Access**: Only accessible to approvers and administrators.

**Behavior**:
- If all reports are approved successfully, returns success response
- If some reports fail, returns partial success with error details
- If all reports fail, returns error response with all failure details

 * @summary Bulk approval multiple invoice reports
 */
export const useBulkApprovalInvoiceReportsHook = () => {
  const bulkApprovalInvoiceReports =
    useCustomClient<BulkApprovalInvoiceReportsResponse>();

  return (
    bulkApprovalInvoiceReportsRequest: BodyType<BulkApprovalInvoiceReportsRequest>,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>
  ) => {
    return bulkApprovalInvoiceReports(
      {
        url: `/api/js/invoice_reports/approving_invoice_reports/bulk_approval`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: bulkApprovalInvoiceReportsRequest,
      },
      options
    );
  };
};

export const useBulkApprovalInvoiceReportsMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | ForbiddenResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useBulkApprovalInvoiceReportsHook>>>,
    TError,
    { data: BodyType<BulkApprovalInvoiceReportsRequest> },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useBulkApprovalInvoiceReportsHook>>>,
  TError,
  { data: BodyType<BulkApprovalInvoiceReportsRequest> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const bulkApprovalInvoiceReports = useBulkApprovalInvoiceReportsHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useBulkApprovalInvoiceReportsHook>>>,
    { data: BodyType<BulkApprovalInvoiceReportsRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return bulkApprovalInvoiceReports(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkApprovalInvoiceReportsMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useBulkApprovalInvoiceReportsHook>>>
>;
export type BulkApprovalInvoiceReportsMutationBody =
  BodyType<BulkApprovalInvoiceReportsRequest>;
export type BulkApprovalInvoiceReportsMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | ForbiddenResponse
>;

/**
 * @summary Bulk approval multiple invoice reports
 */
export const useBulkApprovalInvoiceReports = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | ForbiddenResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useBulkApprovalInvoiceReportsHook>>>,
    TError,
    { data: BodyType<BulkApprovalInvoiceReportsRequest> },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const mutationOptions = useBulkApprovalInvoiceReportsMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Creates a disapproval for an approving invoice report and returns status. <br/>
**Restricted Access**: Only accessible to approvers and administrators.

 * @summary Create a disapproval for an approving invoice report
 */
export const useCreateApprovingInvoiceReportDisapprovalHook = () => {
  const createApprovingInvoiceReportDisapproval =
    useCustomClient<ApprovingInvoiceReportDisapprovalResponse>();

  return (
    id: string,
    approvingInvoiceReportDisapprovalRequest: BodyType<ApprovingInvoiceReportDisapprovalRequest>,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>
  ) => {
    return createApprovingInvoiceReportDisapproval(
      {
        url: `/api/js/invoice_reports/approving_invoice_reports/${id}/disapproval`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: approvingInvoiceReportDisapprovalRequest,
      },
      options
    );
  };
};

export const useCreateApprovingInvoiceReportDisapprovalMutationOptions = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useCreateApprovingInvoiceReportDisapprovalHook>
      >
    >,
    TError,
    { id: string; data: BodyType<ApprovingInvoiceReportDisapprovalRequest> },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseMutationOptions<
  Awaited<
    ReturnType<
      ReturnType<typeof useCreateApprovingInvoiceReportDisapprovalHook>
    >
  >,
  TError,
  { id: string; data: BodyType<ApprovingInvoiceReportDisapprovalRequest> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const createApprovingInvoiceReportDisapproval =
    useCreateApprovingInvoiceReportDisapprovalHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useCreateApprovingInvoiceReportDisapprovalHook>
      >
    >,
    { id: string; data: BodyType<ApprovingInvoiceReportDisapprovalRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return createApprovingInvoiceReportDisapproval(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateApprovingInvoiceReportDisapprovalMutationResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof useCreateApprovingInvoiceReportDisapprovalHook>
    >
  >
>;
export type CreateApprovingInvoiceReportDisapprovalMutationBody =
  BodyType<ApprovingInvoiceReportDisapprovalRequest>;
export type CreateApprovingInvoiceReportDisapprovalMutationError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Create a disapproval for an approving invoice report
 */
export const useCreateApprovingInvoiceReportDisapproval = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useCreateApprovingInvoiceReportDisapprovalHook>
      >
    >,
    TError,
    { id: string; data: BodyType<ApprovingInvoiceReportDisapprovalRequest> },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const mutationOptions =
    useCreateApprovingInvoiceReportDisapprovalMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Get a business document for an approving invoice report. <br/>
**Restricted Access**: Only accessible to approvers and administrators.

 * @summary Get a business document for an approving invoice report
 */
export const useGetApprovingInvoiceReportBusinessDocumentHook = () => {
  const getApprovingInvoiceReportBusinessDocument =
    useCustomClient<ApprovingInvoiceReportBusinessDocumentResponse>();

  return (
    id: string,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>,
    signal?: AbortSignal
  ) => {
    return getApprovingInvoiceReportBusinessDocument(
      {
        url: `/api/js/invoice_reports/approving_invoice_reports/business_documents/${id}`,
        method: 'GET',
        signal,
      },
      options
    );
  };
};

export const getGetApprovingInvoiceReportBusinessDocumentQueryKey = (
  id: string
) => {
  return [
    `/api/js/invoice_reports/approving_invoice_reports/business_documents/${id}`,
  ] as const;
};

export const useGetApprovingInvoiceReportBusinessDocumentQueryOptions = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useGetApprovingInvoiceReportBusinessDocumentHook>
    >
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useGetApprovingInvoiceReportBusinessDocumentHook>
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApprovingInvoiceReportBusinessDocumentQueryKey(id);

  const getApprovingInvoiceReportBusinessDocument =
    useGetApprovingInvoiceReportBusinessDocumentHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useGetApprovingInvoiceReportBusinessDocumentHook>
      >
    >
  > = ({ signal }) =>
    getApprovingInvoiceReportBusinessDocument(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useGetApprovingInvoiceReportBusinessDocumentHook>
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApprovingInvoiceReportBusinessDocumentQueryResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof useGetApprovingInvoiceReportBusinessDocumentHook>
    >
  >
>;
export type GetApprovingInvoiceReportBusinessDocumentQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Get a business document for an approving invoice report
 */
export const useGetApprovingInvoiceReportBusinessDocument = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useGetApprovingInvoiceReportBusinessDocumentHook>
    >
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useGetApprovingInvoiceReportBusinessDocumentHook>
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetApprovingInvoiceReportBusinessDocumentQueryOptions(
    id,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetApprovingInvoiceReportBusinessDocumentSuspenseQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        ReturnType<typeof useGetApprovingInvoiceReportBusinessDocumentHook>
      >
    >,
    TError = ErrorType<
      | BadRequestResponse
      | UnauthorizedResponse
      | ForbiddenResponse
      | NotFoundResponse
      | UnprocessableEntityResponse
    >
  >(
    id: string,
    options?: {
      query?: Partial<
        UseSuspenseQueryOptions<
          Awaited<
            ReturnType<
              ReturnType<
                typeof useGetApprovingInvoiceReportBusinessDocumentHook
              >
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<ReturnType<typeof useCustomClient>>;
    }
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetApprovingInvoiceReportBusinessDocumentQueryKey(id);

    const getApprovingInvoiceReportBusinessDocument =
      useGetApprovingInvoiceReportBusinessDocumentHook();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          ReturnType<typeof useGetApprovingInvoiceReportBusinessDocumentHook>
        >
      >
    > = ({ signal }) =>
      getApprovingInvoiceReportBusinessDocument(id, requestOptions, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!id,
      ...queryOptions,
    } as UseSuspenseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useGetApprovingInvoiceReportBusinessDocumentHook>
        >
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type GetApprovingInvoiceReportBusinessDocumentSuspenseQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<typeof useGetApprovingInvoiceReportBusinessDocumentHook>
      >
    >
  >;
export type GetApprovingInvoiceReportBusinessDocumentSuspenseQueryError =
  ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >;

/**
 * @summary Get a business document for an approving invoice report
 */
export const useGetApprovingInvoiceReportBusinessDocumentSuspense = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useGetApprovingInvoiceReportBusinessDocumentHook>
    >
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useGetApprovingInvoiceReportBusinessDocumentHook>
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useGetApprovingInvoiceReportBusinessDocumentSuspenseQueryOptions(
      id,
      options
    );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Returns a list of available invoice file attachment statuses with their corresponding keys and values. The response varies depending on the system configuration.
 * @summary Get available invoice file attachment statuses
 */
export const useGetInvoiceFilesStatusesHook = () => {
  const getInvoiceFilesStatuses =
    useCustomClient<InvoiceFilesStatusesResponse>();

  return (
    options?: SecondParameter<ReturnType<typeof useCustomClient>>,
    signal?: AbortSignal
  ) => {
    return getInvoiceFilesStatuses(
      {
        url: `/api/js/invoice_reports/invoice_files/statuses`,
        method: 'GET',
        signal,
      },
      options
    );
  };
};

export const getGetInvoiceFilesStatusesQueryKey = () => {
  return [`/api/js/invoice_reports/invoice_files/statuses`] as const;
};

export const useGetInvoiceFilesStatusesQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetInvoiceFilesStatusesHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetInvoiceFilesStatusesHook>>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetInvoiceFilesStatusesQueryKey();

  const getInvoiceFilesStatuses = useGetInvoiceFilesStatusesHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetInvoiceFilesStatusesHook>>>
  > = ({ signal }) => getInvoiceFilesStatuses(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetInvoiceFilesStatusesHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInvoiceFilesStatusesQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetInvoiceFilesStatusesHook>>>
>;
export type GetInvoiceFilesStatusesQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Get available invoice file attachment statuses
 */
export const useGetInvoiceFilesStatuses = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetInvoiceFilesStatusesHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetInvoiceFilesStatusesHook>>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetInvoiceFilesStatusesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetInvoiceFilesStatusesSuspenseQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetInvoiceFilesStatusesHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetInvoiceFilesStatusesHook>>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetInvoiceFilesStatusesQueryKey();

  const getInvoiceFilesStatuses = useGetInvoiceFilesStatusesHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetInvoiceFilesStatusesHook>>>
  > = ({ signal }) => getInvoiceFilesStatuses(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetInvoiceFilesStatusesHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInvoiceFilesStatusesSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetInvoiceFilesStatusesHook>>>
>;
export type GetInvoiceFilesStatusesSuspenseQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Get available invoice file attachment statuses
 */
export const useGetInvoiceFilesStatusesSuspense = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetInvoiceFilesStatusesHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetInvoiceFilesStatusesHook>>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetInvoiceFilesStatusesSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Get a list of invoice report status options
 */
export const useGetInvoiceReportStatusesHook = () => {
  const getInvoiceReportStatuses =
    useCustomClient<InvoiceReportStatusesResponse>();

  return (
    params?: GetInvoiceReportStatusesParams,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>,
    signal?: AbortSignal
  ) => {
    return getInvoiceReportStatuses(
      {
        url: `/api/js/invoice_reports/statuses`,
        method: 'GET',
        params,
        signal,
      },
      options
    );
  };
};

export const getGetInvoiceReportStatusesQueryKey = (
  params?: GetInvoiceReportStatusesParams
) => {
  return [
    `/api/js/invoice_reports/statuses`,
    ...(params ? [params] : []),
  ] as const;
};

export const useGetInvoiceReportStatusesQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetInvoiceReportStatusesHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  params?: GetInvoiceReportStatusesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportStatusesHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetInvoiceReportStatusesQueryKey(params);

  const getInvoiceReportStatuses = useGetInvoiceReportStatusesHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportStatusesHook>>>
  > = ({ signal }) => getInvoiceReportStatuses(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportStatusesHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInvoiceReportStatusesQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportStatusesHook>>>
>;
export type GetInvoiceReportStatusesQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Get a list of invoice report status options
 */
export const useGetInvoiceReportStatuses = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetInvoiceReportStatusesHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  params?: GetInvoiceReportStatusesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportStatusesHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetInvoiceReportStatusesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetInvoiceReportStatusesSuspenseQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetInvoiceReportStatusesHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  params?: GetInvoiceReportStatusesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportStatusesHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetInvoiceReportStatusesQueryKey(params);

  const getInvoiceReportStatuses = useGetInvoiceReportStatusesHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportStatusesHook>>>
  > = ({ signal }) => getInvoiceReportStatuses(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportStatusesHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInvoiceReportStatusesSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportStatusesHook>>>
>;
export type GetInvoiceReportStatusesSuspenseQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Get a list of invoice report status options
 */
export const useGetInvoiceReportStatusesSuspense = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetInvoiceReportStatusesHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  params?: GetInvoiceReportStatusesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportStatusesHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetInvoiceReportStatusesSuspenseQueryOptions(
    params,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Returns a list of payment status options for invoice report search. Each item has display_name (for UI) and value (for API request).
 * @summary Get a list of invoice report payment status options
 */
export const useGetInvoiceReportPaymentStatusesHook = () => {
  const getInvoiceReportPaymentStatuses =
    useCustomClient<InvoiceReportPaymentStatusesResponse>();

  return (
    options?: SecondParameter<ReturnType<typeof useCustomClient>>,
    signal?: AbortSignal
  ) => {
    return getInvoiceReportPaymentStatuses(
      {
        url: `/api/js/invoice_reports/payment_statuses`,
        method: 'GET',
        signal,
      },
      options
    );
  };
};

export const getGetInvoiceReportPaymentStatusesQueryKey = () => {
  return [`/api/js/invoice_reports/payment_statuses`] as const;
};

export const useGetInvoiceReportPaymentStatusesQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetInvoiceReportPaymentStatusesHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useGetInvoiceReportPaymentStatusesHook>>
      >,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetInvoiceReportPaymentStatusesQueryKey();

  const getInvoiceReportPaymentStatuses =
    useGetInvoiceReportPaymentStatusesHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<ReturnType<typeof useGetInvoiceReportPaymentStatusesHook>>
    >
  > = ({ signal }) => getInvoiceReportPaymentStatuses(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useGetInvoiceReportPaymentStatusesHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInvoiceReportPaymentStatusesQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportPaymentStatusesHook>>>
>;
export type GetInvoiceReportPaymentStatusesQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Get a list of invoice report payment status options
 */
export const useGetInvoiceReportPaymentStatuses = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetInvoiceReportPaymentStatusesHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useGetInvoiceReportPaymentStatusesHook>>
      >,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetInvoiceReportPaymentStatusesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetInvoiceReportPaymentStatusesSuspenseQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetInvoiceReportPaymentStatusesHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useGetInvoiceReportPaymentStatusesHook>>
      >,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetInvoiceReportPaymentStatusesQueryKey();

  const getInvoiceReportPaymentStatuses =
    useGetInvoiceReportPaymentStatusesHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<ReturnType<typeof useGetInvoiceReportPaymentStatusesHook>>
    >
  > = ({ signal }) => getInvoiceReportPaymentStatuses(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useGetInvoiceReportPaymentStatusesHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInvoiceReportPaymentStatusesSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportPaymentStatusesHook>>>
>;
export type GetInvoiceReportPaymentStatusesSuspenseQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Get a list of invoice report payment status options
 */
export const useGetInvoiceReportPaymentStatusesSuspense = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetInvoiceReportPaymentStatusesHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useGetInvoiceReportPaymentStatusesHook>>
      >,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useGetInvoiceReportPaymentStatusesSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Copies an invoice report.

 * @summary Copy an invoice report
 */
export const useCopyInvoiceReportHook = () => {
  const copyInvoiceReport = useCustomClient<CopyInvoiceReportResponse>();

  return (
    id: string,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>
  ) => {
    return copyInvoiceReport(
      { url: `/api/js/invoice_reports/${id}/copy`, method: 'POST' },
      options
    );
  };
};

export const useCopyInvoiceReportMutationOptions = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | CommonError
    | NotFoundResponse
    | UnprocessableEntityResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCopyInvoiceReportHook>>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCopyInvoiceReportHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const copyInvoiceReport = useCopyInvoiceReportHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCopyInvoiceReportHook>>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return copyInvoiceReport(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CopyInvoiceReportMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCopyInvoiceReportHook>>>
>;

export type CopyInvoiceReportMutationError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | CommonError
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Copy an invoice report
 */
export const useCopyInvoiceReport = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | CommonError
    | NotFoundResponse
    | UnprocessableEntityResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCopyInvoiceReportHook>>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const mutationOptions = useCopyInvoiceReportMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Cancels an invoice report. <br/>
**Restricted Access**: Only accessible to applicants and administrators. Observers cannot cancel. <br/>
**Business Rules**:
- Cannot cancel if the report is unsubmitted, already canceled, or rejected
- Cannot cancel if the report belongs to a report unit
- Cannot cancel if the report is approved and the report type does not allow cancellation after approval

 * @summary Cancel an invoice report
 */
export const useCancelInvoiceReportHook = () => {
  const cancelInvoiceReport = useCustomClient<CancelInvoiceReportResponse>();

  return (
    id: string,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>
  ) => {
    return cancelInvoiceReport(
      { url: `/api/js/invoice_reports/${id}/cancel`, method: 'POST' },
      options
    );
  };
};

export const useCancelInvoiceReportMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | CommonError | NotFoundResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCancelInvoiceReportHook>>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCancelInvoiceReportHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const cancelInvoiceReport = useCancelInvoiceReportHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCancelInvoiceReportHook>>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return cancelInvoiceReport(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelInvoiceReportMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCancelInvoiceReportHook>>>
>;

export type CancelInvoiceReportMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | CommonError | NotFoundResponse
>;

/**
 * @summary Cancel an invoice report
 */
export const useCancelInvoiceReport = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | CommonError | NotFoundResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCancelInvoiceReportHook>>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const mutationOptions = useCancelInvoiceReportMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Get viewers for an invoice_report
 */
export const useGetInvoiceReportViewersHook = () => {
  const getInvoiceReportViewers =
    useCustomClient<GetInvoiceReportViewersResponse>();

  return (
    id: string,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>,
    signal?: AbortSignal
  ) => {
    return getInvoiceReportViewers(
      { url: `/api/js/invoice_reports/${id}/viewers`, method: 'GET', signal },
      options
    );
  };
};

export const getGetInvoiceReportViewersQueryKey = (id: string) => {
  return [`/api/js/invoice_reports/${id}/viewers`] as const;
};

export const useGetInvoiceReportViewersQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetInvoiceReportViewersHook>>
  >,
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportViewersHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetInvoiceReportViewersQueryKey(id);

  const getInvoiceReportViewers = useGetInvoiceReportViewersHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportViewersHook>>>
  > = ({ signal }) => getInvoiceReportViewers(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportViewersHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInvoiceReportViewersQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportViewersHook>>>
>;
export type GetInvoiceReportViewersQueryError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Get viewers for an invoice_report
 */
export const useGetInvoiceReportViewers = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetInvoiceReportViewersHook>>
  >,
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportViewersHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetInvoiceReportViewersQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetInvoiceReportViewersSuspenseQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetInvoiceReportViewersHook>>
  >,
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportViewersHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetInvoiceReportViewersQueryKey(id);

  const getInvoiceReportViewers = useGetInvoiceReportViewersHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportViewersHook>>>
  > = ({ signal }) => getInvoiceReportViewers(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseSuspenseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportViewersHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInvoiceReportViewersSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportViewersHook>>>
>;
export type GetInvoiceReportViewersSuspenseQueryError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Get viewers for an invoice_report
 */
export const useGetInvoiceReportViewersSuspense = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetInvoiceReportViewersHook>>
  >,
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetInvoiceReportViewersHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetInvoiceReportViewersSuspenseQueryOptions(
    id,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Attaches the given office members as viewers of the invoice_report.
Existing viewers not included in `office_member_ids` are left untouched (this is an additive operation, not a full replace).

 * @summary Add viewers to an invoice_report
 */
export const usePutInvoiceReportViewersHook = () => {
  const putInvoiceReportViewers = useCustomClient<void>();

  return (
    id: string,
    putInvoiceReportViewersRequest: BodyType<PutInvoiceReportViewersRequest>,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>
  ) => {
    return putInvoiceReportViewers(
      {
        url: `/api/js/invoice_reports/${id}/viewers`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: putInvoiceReportViewersRequest,
      },
      options
    );
  };
};

export const usePutInvoiceReportViewersMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | CommonError | NotFoundResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePutInvoiceReportViewersHook>>>,
    TError,
    { id: string; data: BodyType<PutInvoiceReportViewersRequest> },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof usePutInvoiceReportViewersHook>>>,
  TError,
  { id: string; data: BodyType<PutInvoiceReportViewersRequest> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const putInvoiceReportViewers = usePutInvoiceReportViewersHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof usePutInvoiceReportViewersHook>>>,
    { id: string; data: BodyType<PutInvoiceReportViewersRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return putInvoiceReportViewers(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutInvoiceReportViewersMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof usePutInvoiceReportViewersHook>>>
>;
export type PutInvoiceReportViewersMutationBody =
  BodyType<PutInvoiceReportViewersRequest>;
export type PutInvoiceReportViewersMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | CommonError | NotFoundResponse
>;

/**
 * @summary Add viewers to an invoice_report
 */
export const usePutInvoiceReportViewers = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | CommonError | NotFoundResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePutInvoiceReportViewersHook>>>,
    TError,
    { id: string; data: BodyType<PutInvoiceReportViewersRequest> },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const mutationOptions = usePutInvoiceReportViewersMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Remove viewers from an invoice_report
 */
export const useDeleteInvoiceReportViewersHook = () => {
  const deleteInvoiceReportViewers = useCustomClient<void>();

  return (
    id: string,
    deleteInvoiceReportViewersRequest: BodyType<DeleteInvoiceReportViewersRequest>,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>
  ) => {
    return deleteInvoiceReportViewers(
      {
        url: `/api/js/invoice_reports/${id}/viewers`,
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
        data: deleteInvoiceReportViewersRequest,
      },
      options
    );
  };
};

export const useDeleteInvoiceReportViewersMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | CommonError | NotFoundResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeleteInvoiceReportViewersHook>>>,
    TError,
    { id: string; data: BodyType<DeleteInvoiceReportViewersRequest> },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useDeleteInvoiceReportViewersHook>>>,
  TError,
  { id: string; data: BodyType<DeleteInvoiceReportViewersRequest> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const deleteInvoiceReportViewers = useDeleteInvoiceReportViewersHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useDeleteInvoiceReportViewersHook>>>,
    { id: string; data: BodyType<DeleteInvoiceReportViewersRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return deleteInvoiceReportViewers(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteInvoiceReportViewersMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useDeleteInvoiceReportViewersHook>>>
>;
export type DeleteInvoiceReportViewersMutationBody =
  BodyType<DeleteInvoiceReportViewersRequest>;
export type DeleteInvoiceReportViewersMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | CommonError | NotFoundResponse
>;

/**
 * @summary Remove viewers from an invoice_report
 */
export const useDeleteInvoiceReportViewers = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | CommonError | NotFoundResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeleteInvoiceReportViewersHook>>>,
    TError,
    { id: string; data: BodyType<DeleteInvoiceReportViewersRequest> },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const mutationOptions = useDeleteInvoiceReportViewersMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Retrieve invoice report related settings for the current office
 * @summary Get Office Invoice Report Settings
 */
export const useGetOfficeInvoiceReportSettingsHook = () => {
  const getOfficeInvoiceReportSettings =
    useCustomClient<OfficeInvoiceReportSettings>();

  return (
    options?: SecondParameter<ReturnType<typeof useCustomClient>>,
    signal?: AbortSignal
  ) => {
    return getOfficeInvoiceReportSettings(
      { url: `/api/js/office/invoice_report_settings`, method: 'GET', signal },
      options
    );
  };
};

export const getGetOfficeInvoiceReportSettingsQueryKey = () => {
  return [`/api/js/office/invoice_report_settings`] as const;
};

export const useGetOfficeInvoiceReportSettingsQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetOfficeInvoiceReportSettingsHook>>
  >,
  TError = ErrorType<UnauthorizedResponse | ForbiddenResponse>
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useGetOfficeInvoiceReportSettingsHook>>
      >,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOfficeInvoiceReportSettingsQueryKey();

  const getOfficeInvoiceReportSettings =
    useGetOfficeInvoiceReportSettingsHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<ReturnType<typeof useGetOfficeInvoiceReportSettingsHook>>
    >
  > = ({ signal }) => getOfficeInvoiceReportSettings(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useGetOfficeInvoiceReportSettingsHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOfficeInvoiceReportSettingsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetOfficeInvoiceReportSettingsHook>>>
>;
export type GetOfficeInvoiceReportSettingsQueryError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse
>;

/**
 * @summary Get Office Invoice Report Settings
 */
export const useGetOfficeInvoiceReportSettings = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetOfficeInvoiceReportSettingsHook>>
  >,
  TError = ErrorType<UnauthorizedResponse | ForbiddenResponse>
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useGetOfficeInvoiceReportSettingsHook>>
      >,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetOfficeInvoiceReportSettingsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetOfficeInvoiceReportSettingsSuspenseQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetOfficeInvoiceReportSettingsHook>>
  >,
  TError = ErrorType<UnauthorizedResponse | ForbiddenResponse>
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useGetOfficeInvoiceReportSettingsHook>>
      >,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOfficeInvoiceReportSettingsQueryKey();

  const getOfficeInvoiceReportSettings =
    useGetOfficeInvoiceReportSettingsHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<ReturnType<typeof useGetOfficeInvoiceReportSettingsHook>>
    >
  > = ({ signal }) => getOfficeInvoiceReportSettings(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useGetOfficeInvoiceReportSettingsHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOfficeInvoiceReportSettingsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetOfficeInvoiceReportSettingsHook>>>
>;
export type GetOfficeInvoiceReportSettingsSuspenseQueryError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse
>;

/**
 * @summary Get Office Invoice Report Settings
 */
export const useGetOfficeInvoiceReportSettingsSuspense = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetOfficeInvoiceReportSettingsHook>>
  >,
  TError = ErrorType<UnauthorizedResponse | ForbiddenResponse>
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useGetOfficeInvoiceReportSettingsHook>>
      >,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useGetOfficeInvoiceReportSettingsSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
